"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var i = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 13);
}([function (e, t, n) {
  "use strict";

  (function (e) {
    var r;

    function i(e) {
      var t = !1;
      return e ? (t = 10 == r.var.breakpoint ? "SP" : 20 == r.var.breakpoint ? "TB" : "PC", e == t || void 0) : r.var.breakpoint;
    }

    var o, s, a, u;
    n.d(t, "a", function () {
      return r;
    }), n.d(t, "b", function () {
      return i;
    }), r = {}, r.var = {
      breakpoint: -1,
      tmpBreakpoint: -1,
      scrollTop: -1,
      scrollBtm: -1,
      bodyFixedScrollTop: -1,
      tmpWindowWidth: -1
    }, e(window).on("bodyFixedOn", function () {
      r.var.bodyFixedScrollTop = e(window).scrollTop(), e("body").css({
        position: "fixed",
        "overflow-y": "scroll",
        top: -r.var.bodyFixedScrollTop
      });
    }), e(window).on("bodyFixedOff", function () {
      e("body").css({
        position: "",
        "overflow-y": "",
        top: ""
      }), e(window).scrollTop(r.var.bodyFixedScrollTop);
    }), o = function o() {
      var t = i("PC") ? "@sp" : "@pc",
          n = i("PC") ? "@pc" : "@sp";
      e("img").each(function () {
        var r = e(this).attr("src");
        r && r.match(/\@(pc|sp)/) && e(this).attr("src", r.replace(t, n));
      });
    }, s = e(".js-img-change"), a = [], u = function u() {
      a.length < 1 || s.each(function (t) {
        0 === e(this).children("img").length && e(this).append("<img>"), i("PC") ? e(this).children("img").attr("src", a[t].pc) : e(this).children("img").attr("src", a[t].sp);
      });
    }, s.each(function (t) {
      var n = e(this).children("img[data-type=pc]").attr("src"),
          r = e(this).children("img[data-type=sp]").attr("src");
      a[t] = {
        pc: n,
        sp: r
      }, e(this).children("img").length > 1 && (i("PC") ? e(this).children("img").not("img[data-type=pc]").remove() : e(this).children("img").not("img[data-type=sp]").remove());
    }), u(), o(), e(window).on("isDeviceSwitched", function () {
      u(), o();
    }), function () {
      var t = ".p-global-navi",
          n = "".concat(t, "__inner"),
          r = !1,
          i = function i() {
        r = !1, e(t).removeClass("is-screen-on"), e(n).animate({
          left: "-100%"
        }, 400, "easeOutCubic", function () {
          e(this).css({
            left: ""
          }), e(window).trigger("bodyFixedOff");
        });
      };

      e(".c-sp-navi-trigger").on("click", function () {
        r || (r = !0, e(window).trigger("bodyFixedOn"), e(t).addClass("is-screen-on"), e(n).animate({
          left: 0
        }, 400, "easeOutCubic", function () {}));
      }), e(t).on("click", function (e) {
        r && i();
      }), e("".concat(n, ", .c-main-navi, .c-sub-navi")).on("click", function (e) {
        e.stopPropagation();
      }), e(window).on("isDeviceSwitched", function () {
        r && i();
      });
    }(), function () {
      var t = ".p-footer-navi__title",
          n = ".p-footer-navi__items",
          r = function r(t) {
        t.removeClass("is-active"), t.next(n).slideUp(600, "easeOutCubic", function () {
          e(this).css({
            display: ""
          });
        });
      };

      e(t).on("click", function () {
        var t;
        i("PC") || (e(this).hasClass("is-active") ? r(e(this)) : ((t = e(this)).addClass("is-active"), t.next(n).slideDown(600, "easeOutCubic")));
      }), e(window).on("load", function () {
         /* e(t).eq(0).trigger("click");*/
      }), e(window).on("isDeviceSwitched", function () {
        e(n).attr("style", ""), e(t).removeClass("is-active");
      });
    }(), e(window).on("load resize scroll", function () {
      r.var.breakpoint = parseInt(e("body").css("z-index"), 10), r.var.scrollTop = e(window).scrollTop(), r.var.scrollBtm = e(window).scrollTop() + e(window).height();
    }), e(window).on("resize", function () {
      r.var.tmpBreakpoint < 0 && (r.var.tmpBreakpoint = r.var.breakpoint), r.var.tmpBreakpoint !== r.var.breakpoint && (r.var.tmpBreakpoint = parseInt(e("body").css("z-index"), 10), e(window).trigger("isDeviceSwitched")), r.var.tmpWindowWidth != e(window).width() && (r.var.tmpWindowWidth = e(window).width(), e(window).trigger("resizeX"));
    });
  }).call(this, n(2));
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "c", function () {
      return i;
    }), n.d(t, "d", function () {
      return o;
    }), n.d(t, "a", function () {
      return s;
    }), n.d(t, "b", function () {
      return a;
    });
    var r = n(0);

    function i() {
      var t,
          n,
          i,
          o,
          s,
          a,
          u,
          c,
          l,
          f,
          d,
          p = function p(e) {
        e.removeClass("is-full-width").addClass("is-full-height");
      },
          h = function h(e) {
        e.removeClass("is-full-height").addClass("is-full-width");
      },
          g = function g() {
        e('[class*="js-trim-img"]').not(".js-trim-img__target").each(function (d) {
          var g = e(this);
          var v;
          t = (v = g).outerWidth(), n = v.outerHeight(), l = n / t, s = a = "", v.data("img-width") && (i = v.data("img-width").split(","), s = r.a.isDevice("PC") ? i[0] : i[1]), v.data("img-height") && (o = v.data("img-height").split(","), a = r.a.isDevice("PC") ? o[0] : o[1]), u = s || v.find("img")[0].naturalWidth, c = a || v.find("img")[0].naturalHeight, f = c / u, function (e) {
            e.find(".js-trim-img__target").css({
              width: t,
              height: n
            });
          }(g), e(g).hasClass("js-trim-img--cover") && (l <= f && h(g), l > f && p(g)), e(g).hasClass("js-trim-img--contain") && (l <= f && p(g), l > f && h(g));
        }), e("html").trigger("trimImgEnd");
      };

      g(), e(window).on("load scroll resize", function (e) {
        g(), e && "resize" === e.type && (d > 0 && clearTimeout(d), d = setTimeout(function () {
          g();
        }, 500));
      });
    }

    function o() {
      var t,
          n,
          r,
          i,
          o,
          s,
          a,
          u = function u(e) {
        e.removeClass("is-full-width").addClass("is-full-height");
      },
          c = function c(e) {
        e.removeClass("is-full-height").addClass("is-full-width");
      },
          l = function l() {
        e("[class*=js-trim-mov]").each(function () {
          var a = e(this);
          var l;
          t = (l = a).outerWidth(!0), n = l.outerHeight(!0), r = n / t, i = l.find("video").get(0).clientWidth, o = l.find("video").get(0).clientHeight, s = o / i, e(a).hasClass("js-trim-mov--cover") && (r <= s && c(a), r > s && u(a)), e(a).hasClass("js-trim-mov--contain") && (r <= s && u(a), r > s && c(a));
        });
      };

      l(), e(window).on("load scroll resize", function (e) {
        l(), e && "resize" === e.type && (a > 0 && clearTimeout(a), a = setTimeout(function () {
          l();
        }, 500));
      });
    }

    function s(t, n) {
      e(n).on("mouseenter", function () {
        e(this).parents(t).addClass("is-hover");
      }).on("mouseleave", function () {
        e(this).parents(t).removeClass("is-hover");
      });
    }

    function a() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".js-scroll-add-class";
      var n = arguments.length > 1 ? arguments[1] : undefined;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .35;
      e(window).on("load resize scroll", function () {
        e(t).each(function () {
          var t = e(this).offset().top,
              o = e(n || this);
          r.a.var.scrollBtm - e(window).height() * i > t && o.addClass("is-animated").trigger("jsScrollAddClassEnd");
        });
      });
    }
  }).call(this, n(2));
}, function (e, t, n) {
  var r;
  /*!
   * jQuery JavaScript Library v3.4.1
   * https://jquery.com/
   *
   * Includes Sizzle.js
   * https://sizzlejs.com/
   *
   * Copyright JS Foundation and other contributors
   * Released under the MIT license
   * https://jquery.org/license
   *
   * Date: 2019-05-01T21:04Z
   */

  !function (t, n) {
    "use strict";

    "object" == _typeof(e.exports) ? e.exports = t.document ? n(t, !0) : function (e) {
      if (!e.document) throw new Error("jQuery requires a window with a document");
      return n(e);
    } : n(t);
  }("undefined" != typeof window ? window : this, function (n, i) {
    "use strict";

    var o = [],
        s = n.document,
        a = Object.getPrototypeOf,
        u = o.slice,
        c = o.concat,
        l = o.push,
        f = o.indexOf,
        d = {},
        p = d.toString,
        h = d.hasOwnProperty,
        g = h.toString,
        v = g.call(Object),
        m = {},
        y = function y(e) {
      return "function" == typeof e && "number" != typeof e.nodeType;
    },
        x = function x(e) {
      return null != e && e === e.window;
    },
        b = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };

    function w(e, t, n) {
      var r,
          i,
          o = (n = n || s).createElement("script");
      if (o.text = e, t) for (r in b) {
        (i = t[r] || t.getAttribute && t.getAttribute(r)) && o.setAttribute(r, i);
      }
      n.head.appendChild(o).parentNode.removeChild(o);
    }

    function C(e) {
      return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? d[p.call(e)] || "object" : _typeof(e);
    }

    var T = function T(e, t) {
      return new T.fn.init(e, t);
    },
        k = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

    function S(e) {
      var t = !!e && "length" in e && e.length,
          n = C(e);
      return !y(e) && !x(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
    }

    T.fn = T.prototype = {
      jquery: "3.4.1",
      constructor: T,
      length: 0,
      toArray: function toArray() {
        return u.call(this);
      },
      get: function get(e) {
        return null == e ? u.call(this) : e < 0 ? this[e + this.length] : this[e];
      },
      pushStack: function pushStack(e) {
        var t = T.merge(this.constructor(), e);
        return t.prevObject = this, t;
      },
      each: function each(e) {
        return T.each(this, e);
      },
      map: function map(e) {
        return this.pushStack(T.map(this, function (t, n) {
          return e.call(t, n, t);
        }));
      },
      slice: function slice() {
        return this.pushStack(u.apply(this, arguments));
      },
      first: function first() {
        return this.eq(0);
      },
      last: function last() {
        return this.eq(-1);
      },
      eq: function eq(e) {
        var t = this.length,
            n = +e + (e < 0 ? t : 0);
        return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
      },
      end: function end() {
        return this.prevObject || this.constructor();
      },
      push: l,
      sort: o.sort,
      splice: o.splice
    }, T.extend = T.fn.extend = function () {
      var e,
          t,
          n,
          r,
          i,
          o,
          s = arguments[0] || {},
          a = 1,
          u = arguments.length,
          c = !1;

      for ("boolean" == typeof s && (c = s, s = arguments[a] || {}, a++), "object" == _typeof(s) || y(s) || (s = {}), a === u && (s = this, a--); a < u; a++) {
        if (null != (e = arguments[a])) for (t in e) {
          r = e[t], "__proto__" !== t && s !== r && (c && r && (T.isPlainObject(r) || (i = Array.isArray(r))) ? (n = s[t], o = i && !Array.isArray(n) ? [] : i || T.isPlainObject(n) ? n : {}, i = !1, s[t] = T.extend(c, o, r)) : void 0 !== r && (s[t] = r));
        }
      }

      return s;
    }, T.extend({
      expando: "jQuery" + ("3.4.1" + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function error(e) {
        throw new Error(e);
      },
      noop: function noop() {},
      isPlainObject: function isPlainObject(e) {
        var t, n;
        return !(!e || "[object Object]" !== p.call(e)) && (!(t = a(e)) || "function" == typeof (n = h.call(t, "constructor") && t.constructor) && g.call(n) === v);
      },
      isEmptyObject: function isEmptyObject(e) {
        var t;

        for (t in e) {
          return !1;
        }

        return !0;
      },
      globalEval: function globalEval(e, t) {
        w(e, {
          nonce: t && t.nonce
        });
      },
      each: function each(e, t) {
        var n,
            r = 0;
        if (S(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++) {
          ;
        } else for (r in e) {
          if (!1 === t.call(e[r], r, e[r])) break;
        }
        return e;
      },
      trim: function trim(e) {
        return null == e ? "" : (e + "").replace(k, "");
      },
      makeArray: function makeArray(e, t) {
        var n = t || [];
        return null != e && (S(Object(e)) ? T.merge(n, "string" == typeof e ? [e] : e) : l.call(n, e)), n;
      },
      inArray: function inArray(e, t, n) {
        return null == t ? -1 : f.call(t, e, n);
      },
      merge: function merge(e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
          e[i++] = t[r];
        }

        return e.length = i, e;
      },
      grep: function grep(e, t, n) {
        for (var r = [], i = 0, o = e.length, s = !n; i < o; i++) {
          !t(e[i], i) !== s && r.push(e[i]);
        }

        return r;
      },
      map: function map(e, t, n) {
        var r,
            i,
            o = 0,
            s = [];
        if (S(e)) for (r = e.length; o < r; o++) {
          null != (i = t(e[o], o, n)) && s.push(i);
        } else for (o in e) {
          null != (i = t(e[o], o, n)) && s.push(i);
        }
        return c.apply([], s);
      },
      guid: 1,
      support: m
    }), "function" == typeof Symbol && (T.fn[Symbol.iterator] = o[Symbol.iterator]), T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
      d["[object " + t + "]"] = t.toLowerCase();
    });

    var E =
    /*!
     * Sizzle CSS Selector Engine v2.3.4
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://js.foundation/
     *
     * Date: 2019-04-08
     */
    function (e) {
      var t,
          n,
          r,
          i,
          o,
          s,
          a,
          u,
          c,
          l,
          f,
          d,
          p,
          h,
          g,
          v,
          m,
          y,
          x,
          b = "sizzle" + 1 * new Date(),
          w = e.document,
          C = 0,
          T = 0,
          k = ue(),
          S = ue(),
          E = ue(),
          j = ue(),
          D = function D(e, t) {
        return e === t && (f = !0), 0;
      },
          A = {}.hasOwnProperty,
          N = [],
          O = N.pop,
          q = N.push,
          L = N.push,
          _ = N.slice,
          M = function M(e, t) {
        for (var n = 0, r = e.length; n < r; n++) {
          if (e[n] === t) return n;
        }

        return -1;
      },
          P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
          I = "[\\x20\\t\\r\\n\\f]",
          H = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
          $ = "\\[" + I + "*(" + H + ")(?:" + I + "*([*^$|!~]?=)" + I + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + H + "))|)" + I + "*\\]",
          R = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + $ + ")*)|.*)\\)|)",
          B = new RegExp(I + "+", "g"),
          W = new RegExp("^" + I + "+|((?:^|[^\\\\])(?:\\\\.)*)" + I + "+$", "g"),
          F = new RegExp("^" + I + "*," + I + "*"),
          z = new RegExp("^" + I + "*([>+~]|" + I + ")" + I + "*"),
          U = new RegExp(I + "|>"),
          X = new RegExp(R),
          Q = new RegExp("^" + H + "$"),
          V = {
        ID: new RegExp("^#(" + H + ")"),
        CLASS: new RegExp("^\\.(" + H + ")"),
        TAG: new RegExp("^(" + H + "|[*])"),
        ATTR: new RegExp("^" + $),
        PSEUDO: new RegExp("^" + R),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + I + "*(even|odd|(([+-]|)(\\d*)n|)" + I + "*(?:([+-]|)" + I + "*(\\d+)|))" + I + "*\\)|)", "i"),
        bool: new RegExp("^(?:" + P + ")$", "i"),
        needsContext: new RegExp("^" + I + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + I + "*((?:-\\d)?\\d*)" + I + "*\\)|)(?=[^-]|$)", "i")
      },
          G = /HTML$/i,
          Y = /^(?:input|select|textarea|button)$/i,
          J = /^h\d$/i,
          K = /^[^{]+\{\s*\[native \w/,
          Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
          ee = /[+~]/,
          te = new RegExp("\\\\([\\da-f]{1,6}" + I + "?|(" + I + ")|.)", "ig"),
          ne = function ne(e, t, n) {
        var r = "0x" + t - 65536;
        return r != r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
      },
          re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
          ie = function ie(e, t) {
        return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
      },
          oe = function oe() {
        d();
      },
          se = be(function (e) {
        return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
      }, {
        dir: "parentNode",
        next: "legend"
      });

      try {
        L.apply(N = _.call(w.childNodes), w.childNodes), N[w.childNodes.length].nodeType;
      } catch (e) {
        L = {
          apply: N.length ? function (e, t) {
            q.apply(e, _.call(t));
          } : function (e, t) {
            for (var n = e.length, r = 0; e[n++] = t[r++];) {
              ;
            }

            e.length = n - 1;
          }
        };
      }

      function ae(e, t, r, i) {
        var o,
            a,
            c,
            l,
            f,
            h,
            m,
            y = t && t.ownerDocument,
            C = t ? t.nodeType : 9;
        if (r = r || [], "string" != typeof e || !e || 1 !== C && 9 !== C && 11 !== C) return r;

        if (!i && ((t ? t.ownerDocument || t : w) !== p && d(t), t = t || p, g)) {
          if (11 !== C && (f = Z.exec(e))) if (o = f[1]) {
            if (9 === C) {
              if (!(c = t.getElementById(o))) return r;
              if (c.id === o) return r.push(c), r;
            } else if (y && (c = y.getElementById(o)) && x(t, c) && c.id === o) return r.push(c), r;
          } else {
            if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;
            if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName) return L.apply(r, t.getElementsByClassName(o)), r;
          }

          if (n.qsa && !j[e + " "] && (!v || !v.test(e)) && (1 !== C || "object" !== t.nodeName.toLowerCase())) {
            if (m = e, y = t, 1 === C && U.test(e)) {
              for ((l = t.getAttribute("id")) ? l = l.replace(re, ie) : t.setAttribute("id", l = b), a = (h = s(e)).length; a--;) {
                h[a] = "#" + l + " " + xe(h[a]);
              }

              m = h.join(","), y = ee.test(e) && me(t.parentNode) || t;
            }

            try {
              return L.apply(r, y.querySelectorAll(m)), r;
            } catch (t) {
              j(e, !0);
            } finally {
              l === b && t.removeAttribute("id");
            }
          }
        }

        return u(e.replace(W, "$1"), t, r, i);
      }

      function ue() {
        var e = [];
        return function t(n, i) {
          return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i;
        };
      }

      function ce(e) {
        return e[b] = !0, e;
      }

      function le(e) {
        var t = p.createElement("fieldset");

        try {
          return !!e(t);
        } catch (e) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), t = null;
        }
      }

      function fe(e, t) {
        for (var n = e.split("|"), i = n.length; i--;) {
          r.attrHandle[n[i]] = t;
        }
      }

      function de(e, t) {
        var n = t && e,
            r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
        if (r) return r;
        if (n) for (; n = n.nextSibling;) {
          if (n === t) return -1;
        }
        return e ? 1 : -1;
      }

      function pe(e) {
        return function (t) {
          return "input" === t.nodeName.toLowerCase() && t.type === e;
        };
      }

      function he(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return ("input" === n || "button" === n) && t.type === e;
        };
      }

      function ge(e) {
        return function (t) {
          return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && se(t) === e : t.disabled === e : "label" in t && t.disabled === e;
        };
      }

      function ve(e) {
        return ce(function (t) {
          return t = +t, ce(function (n, r) {
            for (var i, o = e([], n.length, t), s = o.length; s--;) {
              n[i = o[s]] && (n[i] = !(r[i] = n[i]));
            }
          });
        });
      }

      function me(e) {
        return e && void 0 !== e.getElementsByTagName && e;
      }

      for (t in n = ae.support = {}, o = ae.isXML = function (e) {
        var t = e.namespaceURI,
            n = (e.ownerDocument || e).documentElement;
        return !G.test(t || n && n.nodeName || "HTML");
      }, d = ae.setDocument = function (e) {
        var t,
            i,
            s = e ? e.ownerDocument || e : w;
        return s !== p && 9 === s.nodeType && s.documentElement ? (h = (p = s).documentElement, g = !o(p), w !== p && (i = p.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", oe, !1) : i.attachEvent && i.attachEvent("onunload", oe)), n.attributes = le(function (e) {
          return e.className = "i", !e.getAttribute("className");
        }), n.getElementsByTagName = le(function (e) {
          return e.appendChild(p.createComment("")), !e.getElementsByTagName("*").length;
        }), n.getElementsByClassName = K.test(p.getElementsByClassName), n.getById = le(function (e) {
          return h.appendChild(e).id = b, !p.getElementsByName || !p.getElementsByName(b).length;
        }), n.getById ? (r.filter.ID = function (e) {
          var t = e.replace(te, ne);
          return function (e) {
            return e.getAttribute("id") === t;
          };
        }, r.find.ID = function (e, t) {
          if (void 0 !== t.getElementById && g) {
            var n = t.getElementById(e);
            return n ? [n] : [];
          }
        }) : (r.filter.ID = function (e) {
          var t = e.replace(te, ne);
          return function (e) {
            var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
            return n && n.value === t;
          };
        }, r.find.ID = function (e, t) {
          if (void 0 !== t.getElementById && g) {
            var n,
                r,
                i,
                o = t.getElementById(e);

            if (o) {
              if ((n = o.getAttributeNode("id")) && n.value === e) return [o];

              for (i = t.getElementsByName(e), r = 0; o = i[r++];) {
                if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
              }
            }

            return [];
          }
        }), r.find.TAG = n.getElementsByTagName ? function (e, t) {
          return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
        } : function (e, t) {
          var n,
              r = [],
              i = 0,
              o = t.getElementsByTagName(e);

          if ("*" === e) {
            for (; n = o[i++];) {
              1 === n.nodeType && r.push(n);
            }

            return r;
          }

          return o;
        }, r.find.CLASS = n.getElementsByClassName && function (e, t) {
          if (void 0 !== t.getElementsByClassName && g) return t.getElementsByClassName(e);
        }, m = [], v = [], (n.qsa = K.test(p.querySelectorAll)) && (le(function (e) {
          h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + I + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || v.push("\\[" + I + "*(?:value|" + P + ")"), e.querySelectorAll("[id~=" + b + "-]").length || v.push("~="), e.querySelectorAll(":checked").length || v.push(":checked"), e.querySelectorAll("a#" + b + "+*").length || v.push(".#.+[+~]");
        }), le(function (e) {
          e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
          var t = p.createElement("input");
          t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && v.push("name" + I + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), v.push(",.*:");
        })), (n.matchesSelector = K.test(y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && le(function (e) {
          n.disconnectedMatch = y.call(e, "*"), y.call(e, "[s!='']:x"), m.push("!=", R);
        }), v = v.length && new RegExp(v.join("|")), m = m.length && new RegExp(m.join("|")), t = K.test(h.compareDocumentPosition), x = t || K.test(h.contains) ? function (e, t) {
          var n = 9 === e.nodeType ? e.documentElement : e,
              r = t && t.parentNode;
          return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
        } : function (e, t) {
          if (t) for (; t = t.parentNode;) {
            if (t === e) return !0;
          }
          return !1;
        }, D = t ? function (e, t) {
          if (e === t) return f = !0, 0;
          var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
          return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === p || e.ownerDocument === w && x(w, e) ? -1 : t === p || t.ownerDocument === w && x(w, t) ? 1 : l ? M(l, e) - M(l, t) : 0 : 4 & r ? -1 : 1);
        } : function (e, t) {
          if (e === t) return f = !0, 0;
          var n,
              r = 0,
              i = e.parentNode,
              o = t.parentNode,
              s = [e],
              a = [t];
          if (!i || !o) return e === p ? -1 : t === p ? 1 : i ? -1 : o ? 1 : l ? M(l, e) - M(l, t) : 0;
          if (i === o) return de(e, t);

          for (n = e; n = n.parentNode;) {
            s.unshift(n);
          }

          for (n = t; n = n.parentNode;) {
            a.unshift(n);
          }

          for (; s[r] === a[r];) {
            r++;
          }

          return r ? de(s[r], a[r]) : s[r] === w ? -1 : a[r] === w ? 1 : 0;
        }, p) : p;
      }, ae.matches = function (e, t) {
        return ae(e, null, null, t);
      }, ae.matchesSelector = function (e, t) {
        if ((e.ownerDocument || e) !== p && d(e), n.matchesSelector && g && !j[t + " "] && (!m || !m.test(t)) && (!v || !v.test(t))) try {
          var r = y.call(e, t);
          if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
        } catch (e) {
          j(t, !0);
        }
        return ae(t, p, null, [e]).length > 0;
      }, ae.contains = function (e, t) {
        return (e.ownerDocument || e) !== p && d(e), x(e, t);
      }, ae.attr = function (e, t) {
        (e.ownerDocument || e) !== p && d(e);
        var i = r.attrHandle[t.toLowerCase()],
            o = i && A.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
        return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
      }, ae.escape = function (e) {
        return (e + "").replace(re, ie);
      }, ae.error = function (e) {
        throw new Error("Syntax error, unrecognized expression: " + e);
      }, ae.uniqueSort = function (e) {
        var t,
            r = [],
            i = 0,
            o = 0;

        if (f = !n.detectDuplicates, l = !n.sortStable && e.slice(0), e.sort(D), f) {
          for (; t = e[o++];) {
            t === e[o] && (i = r.push(o));
          }

          for (; i--;) {
            e.splice(r[i], 1);
          }
        }

        return l = null, e;
      }, i = ae.getText = function (e) {
        var t,
            n = "",
            r = 0,
            o = e.nodeType;

        if (o) {
          if (1 === o || 9 === o || 11 === o) {
            if ("string" == typeof e.textContent) return e.textContent;

            for (e = e.firstChild; e; e = e.nextSibling) {
              n += i(e);
            }
          } else if (3 === o || 4 === o) return e.nodeValue;
        } else for (; t = e[r++];) {
          n += i(t);
        }

        return n;
      }, (r = ae.selectors = {
        cacheLength: 50,
        createPseudo: ce,
        match: V,
        attrHandle: {},
        find: {},
        relative: {
          ">": {
            dir: "parentNode",
            first: !0
          },
          " ": {
            dir: "parentNode"
          },
          "+": {
            dir: "previousSibling",
            first: !0
          },
          "~": {
            dir: "previousSibling"
          }
        },
        preFilter: {
          ATTR: function ATTR(e) {
            return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
          },
          CHILD: function CHILD(e) {
            return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && ae.error(e[0]), e;
          },
          PSEUDO: function PSEUDO(e) {
            var t,
                n = !e[6] && e[2];
            return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = s(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
          }
        },
        filter: {
          TAG: function TAG(e) {
            var t = e.replace(te, ne).toLowerCase();
            return "*" === e ? function () {
              return !0;
            } : function (e) {
              return e.nodeName && e.nodeName.toLowerCase() === t;
            };
          },
          CLASS: function CLASS(e) {
            var t = k[e + " "];
            return t || (t = new RegExp("(^|" + I + ")" + e + "(" + I + "|$)")) && k(e, function (e) {
              return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
            });
          },
          ATTR: function ATTR(e, t, n) {
            return function (r) {
              var i = ae.attr(r, e);
              return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace(B, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
            };
          },
          CHILD: function CHILD(e, t, n, r, i) {
            var o = "nth" !== e.slice(0, 3),
                s = "last" !== e.slice(-4),
                a = "of-type" === t;
            return 1 === r && 0 === i ? function (e) {
              return !!e.parentNode;
            } : function (t, n, u) {
              var c,
                  l,
                  f,
                  d,
                  p,
                  h,
                  g = o !== s ? "nextSibling" : "previousSibling",
                  v = t.parentNode,
                  m = a && t.nodeName.toLowerCase(),
                  y = !u && !a,
                  x = !1;

              if (v) {
                if (o) {
                  for (; g;) {
                    for (d = t; d = d[g];) {
                      if (a ? d.nodeName.toLowerCase() === m : 1 === d.nodeType) return !1;
                    }

                    h = g = "only" === e && !h && "nextSibling";
                  }

                  return !0;
                }

                if (h = [s ? v.firstChild : v.lastChild], s && y) {
                  for (x = (p = (c = (l = (f = (d = v)[b] || (d[b] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === C && c[1]) && c[2], d = p && v.childNodes[p]; d = ++p && d && d[g] || (x = p = 0) || h.pop();) {
                    if (1 === d.nodeType && ++x && d === t) {
                      l[e] = [C, p, x];
                      break;
                    }
                  }
                } else if (y && (x = p = (c = (l = (f = (d = t)[b] || (d[b] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === C && c[1]), !1 === x) for (; (d = ++p && d && d[g] || (x = p = 0) || h.pop()) && ((a ? d.nodeName.toLowerCase() !== m : 1 !== d.nodeType) || !++x || (y && ((l = (f = d[b] || (d[b] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] = [C, x]), d !== t));) {
                  ;
                }

                return (x -= i) === r || x % r == 0 && x / r >= 0;
              }
            };
          },
          PSEUDO: function PSEUDO(e, t) {
            var n,
                i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
            return i[b] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? ce(function (e, n) {
              for (var r, o = i(e, t), s = o.length; s--;) {
                e[r = M(e, o[s])] = !(n[r] = o[s]);
              }
            }) : function (e) {
              return i(e, 0, n);
            }) : i;
          }
        },
        pseudos: {
          not: ce(function (e) {
            var t = [],
                n = [],
                r = a(e.replace(W, "$1"));
            return r[b] ? ce(function (e, t, n, i) {
              for (var o, s = r(e, null, i, []), a = e.length; a--;) {
                (o = s[a]) && (e[a] = !(t[a] = o));
              }
            }) : function (e, i, o) {
              return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
            };
          }),
          has: ce(function (e) {
            return function (t) {
              return ae(e, t).length > 0;
            };
          }),
          contains: ce(function (e) {
            return e = e.replace(te, ne), function (t) {
              return (t.textContent || i(t)).indexOf(e) > -1;
            };
          }),
          lang: ce(function (e) {
            return Q.test(e || "") || ae.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(), function (t) {
              var n;

              do {
                if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
              } while ((t = t.parentNode) && 1 === t.nodeType);

              return !1;
            };
          }),
          target: function target(t) {
            var n = e.location && e.location.hash;
            return n && n.slice(1) === t.id;
          },
          root: function root(e) {
            return e === h;
          },
          focus: function focus(e) {
            return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
          },
          enabled: ge(!1),
          disabled: ge(!0),
          checked: function checked(e) {
            var t = e.nodeName.toLowerCase();
            return "input" === t && !!e.checked || "option" === t && !!e.selected;
          },
          selected: function selected(e) {
            return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
          },
          empty: function empty(e) {
            for (e = e.firstChild; e; e = e.nextSibling) {
              if (e.nodeType < 6) return !1;
            }

            return !0;
          },
          parent: function parent(e) {
            return !r.pseudos.empty(e);
          },
          header: function header(e) {
            return J.test(e.nodeName);
          },
          input: function input(e) {
            return Y.test(e.nodeName);
          },
          button: function button(e) {
            var t = e.nodeName.toLowerCase();
            return "input" === t && "button" === e.type || "button" === t;
          },
          text: function text(e) {
            var t;
            return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
          },
          first: ve(function () {
            return [0];
          }),
          last: ve(function (e, t) {
            return [t - 1];
          }),
          eq: ve(function (e, t, n) {
            return [n < 0 ? n + t : n];
          }),
          even: ve(function (e, t) {
            for (var n = 0; n < t; n += 2) {
              e.push(n);
            }

            return e;
          }),
          odd: ve(function (e, t) {
            for (var n = 1; n < t; n += 2) {
              e.push(n);
            }

            return e;
          }),
          lt: ve(function (e, t, n) {
            for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0;) {
              e.push(r);
            }

            return e;
          }),
          gt: ve(function (e, t, n) {
            for (var r = n < 0 ? n + t : n; ++r < t;) {
              e.push(r);
            }

            return e;
          })
        }
      }).pseudos.nth = r.pseudos.eq, {
        radio: !0,
        checkbox: !0,
        file: !0,
        password: !0,
        image: !0
      }) {
        r.pseudos[t] = pe(t);
      }

      for (t in {
        submit: !0,
        reset: !0
      }) {
        r.pseudos[t] = he(t);
      }

      function ye() {}

      function xe(e) {
        for (var t = 0, n = e.length, r = ""; t < n; t++) {
          r += e[t].value;
        }

        return r;
      }

      function be(e, t, n) {
        var r = t.dir,
            i = t.next,
            o = i || r,
            s = n && "parentNode" === o,
            a = T++;
        return t.first ? function (t, n, i) {
          for (; t = t[r];) {
            if (1 === t.nodeType || s) return e(t, n, i);
          }

          return !1;
        } : function (t, n, u) {
          var c,
              l,
              f,
              d = [C, a];

          if (u) {
            for (; t = t[r];) {
              if ((1 === t.nodeType || s) && e(t, n, u)) return !0;
            }
          } else for (; t = t[r];) {
            if (1 === t.nodeType || s) if (l = (f = t[b] || (t[b] = {}))[t.uniqueID] || (f[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[r] || t;else {
              if ((c = l[o]) && c[0] === C && c[1] === a) return d[2] = c[2];
              if (l[o] = d, d[2] = e(t, n, u)) return !0;
            }
          }

          return !1;
        };
      }

      function we(e) {
        return e.length > 1 ? function (t, n, r) {
          for (var i = e.length; i--;) {
            if (!e[i](t, n, r)) return !1;
          }

          return !0;
        } : e[0];
      }

      function Ce(e, t, n, r, i) {
        for (var o, s = [], a = 0, u = e.length, c = null != t; a < u; a++) {
          (o = e[a]) && (n && !n(o, r, i) || (s.push(o), c && t.push(a)));
        }

        return s;
      }

      function Te(e, t, n, r, i, o) {
        return r && !r[b] && (r = Te(r)), i && !i[b] && (i = Te(i, o)), ce(function (o, s, a, u) {
          var c,
              l,
              f,
              d = [],
              p = [],
              h = s.length,
              g = o || function (e, t, n) {
            for (var r = 0, i = t.length; r < i; r++) {
              ae(e, t[r], n);
            }

            return n;
          }(t || "*", a.nodeType ? [a] : a, []),
              v = !e || !o && t ? g : Ce(g, d, e, a, u),
              m = n ? i || (o ? e : h || r) ? [] : s : v;

          if (n && n(v, m, a, u), r) for (c = Ce(m, p), r(c, [], a, u), l = c.length; l--;) {
            (f = c[l]) && (m[p[l]] = !(v[p[l]] = f));
          }

          if (o) {
            if (i || e) {
              if (i) {
                for (c = [], l = m.length; l--;) {
                  (f = m[l]) && c.push(v[l] = f);
                }

                i(null, m = [], c, u);
              }

              for (l = m.length; l--;) {
                (f = m[l]) && (c = i ? M(o, f) : d[l]) > -1 && (o[c] = !(s[c] = f));
              }
            }
          } else m = Ce(m === s ? m.splice(h, m.length) : m), i ? i(null, s, m, u) : L.apply(s, m);
        });
      }

      function ke(e) {
        for (var t, n, i, o = e.length, s = r.relative[e[0].type], a = s || r.relative[" "], u = s ? 1 : 0, l = be(function (e) {
          return e === t;
        }, a, !0), f = be(function (e) {
          return M(t, e) > -1;
        }, a, !0), d = [function (e, n, r) {
          var i = !s && (r || n !== c) || ((t = n).nodeType ? l(e, n, r) : f(e, n, r));
          return t = null, i;
        }]; u < o; u++) {
          if (n = r.relative[e[u].type]) d = [be(we(d), n)];else {
            if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
              for (i = ++u; i < o && !r.relative[e[i].type]; i++) {
                ;
              }

              return Te(u > 1 && we(d), u > 1 && xe(e.slice(0, u - 1).concat({
                value: " " === e[u - 2].type ? "*" : ""
              })).replace(W, "$1"), n, u < i && ke(e.slice(u, i)), i < o && ke(e = e.slice(i)), i < o && xe(e));
            }

            d.push(n);
          }
        }

        return we(d);
      }

      return ye.prototype = r.filters = r.pseudos, r.setFilters = new ye(), s = ae.tokenize = function (e, t) {
        var n,
            i,
            o,
            s,
            a,
            u,
            c,
            l = S[e + " "];
        if (l) return t ? 0 : l.slice(0);

        for (a = e, u = [], c = r.preFilter; a;) {
          for (s in n && !(i = F.exec(a)) || (i && (a = a.slice(i[0].length) || a), u.push(o = [])), n = !1, (i = z.exec(a)) && (n = i.shift(), o.push({
            value: n,
            type: i[0].replace(W, " ")
          }), a = a.slice(n.length)), r.filter) {
            !(i = V[s].exec(a)) || c[s] && !(i = c[s](i)) || (n = i.shift(), o.push({
              value: n,
              type: s,
              matches: i
            }), a = a.slice(n.length));
          }

          if (!n) break;
        }

        return t ? a.length : a ? ae.error(e) : S(e, u).slice(0);
      }, a = ae.compile = function (e, t) {
        var n,
            i = [],
            o = [],
            a = E[e + " "];

        if (!a) {
          for (t || (t = s(e)), n = t.length; n--;) {
            (a = ke(t[n]))[b] ? i.push(a) : o.push(a);
          }

          (a = E(e, function (e, t) {
            var n = t.length > 0,
                i = e.length > 0,
                o = function o(_o, s, a, u, l) {
              var f,
                  h,
                  v,
                  m = 0,
                  y = "0",
                  x = _o && [],
                  b = [],
                  w = c,
                  T = _o || i && r.find.TAG("*", l),
                  k = C += null == w ? 1 : Math.random() || .1,
                  S = T.length;

              for (l && (c = s === p || s || l); y !== S && null != (f = T[y]); y++) {
                if (i && f) {
                  for (h = 0, s || f.ownerDocument === p || (d(f), a = !g); v = e[h++];) {
                    if (v(f, s || p, a)) {
                      u.push(f);
                      break;
                    }
                  }

                  l && (C = k);
                }

                n && ((f = !v && f) && m--, _o && x.push(f));
              }

              if (m += y, n && y !== m) {
                for (h = 0; v = t[h++];) {
                  v(x, b, s, a);
                }

                if (_o) {
                  if (m > 0) for (; y--;) {
                    x[y] || b[y] || (b[y] = O.call(u));
                  }
                  b = Ce(b);
                }

                L.apply(u, b), l && !_o && b.length > 0 && m + t.length > 1 && ae.uniqueSort(u);
              }

              return l && (C = k, c = w), x;
            };

            return n ? ce(o) : o;
          }(o, i))).selector = e;
        }

        return a;
      }, u = ae.select = function (e, t, n, i) {
        var o,
            u,
            c,
            l,
            f,
            d = "function" == typeof e && e,
            p = !i && s(e = d.selector || e);

        if (n = n || [], 1 === p.length) {
          if ((u = p[0] = p[0].slice(0)).length > 2 && "ID" === (c = u[0]).type && 9 === t.nodeType && g && r.relative[u[1].type]) {
            if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
            d && (t = t.parentNode), e = e.slice(u.shift().value.length);
          }

          for (o = V.needsContext.test(e) ? 0 : u.length; o-- && (c = u[o], !r.relative[l = c.type]);) {
            if ((f = r.find[l]) && (i = f(c.matches[0].replace(te, ne), ee.test(u[0].type) && me(t.parentNode) || t))) {
              if (u.splice(o, 1), !(e = i.length && xe(u))) return L.apply(n, i), n;
              break;
            }
          }
        }

        return (d || a(e, p))(i, t, !g, n, !t || ee.test(e) && me(t.parentNode) || t), n;
      }, n.sortStable = b.split("").sort(D).join("") === b, n.detectDuplicates = !!f, d(), n.sortDetached = le(function (e) {
        return 1 & e.compareDocumentPosition(p.createElement("fieldset"));
      }), le(function (e) {
        return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
      }) || fe("type|href|height|width", function (e, t, n) {
        if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
      }), n.attributes && le(function (e) {
        return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
      }) || fe("value", function (e, t, n) {
        if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
      }), le(function (e) {
        return null == e.getAttribute("disabled");
      }) || fe(P, function (e, t, n) {
        var r;
        if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
      }), ae;
    }(n);

    T.find = E, T.expr = E.selectors, T.expr[":"] = T.expr.pseudos, T.uniqueSort = T.unique = E.uniqueSort, T.text = E.getText, T.isXMLDoc = E.isXML, T.contains = E.contains, T.escapeSelector = E.escape;

    var j = function j(e, t, n) {
      for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) {
        if (1 === e.nodeType) {
          if (i && T(e).is(n)) break;
          r.push(e);
        }
      }

      return r;
    },
        D = function D(e, t) {
      for (var n = []; e; e = e.nextSibling) {
        1 === e.nodeType && e !== t && n.push(e);
      }

      return n;
    },
        A = T.expr.match.needsContext;

    function N(e, t) {
      return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }

    var O = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function q(e, t, n) {
      return y(t) ? T.grep(e, function (e, r) {
        return !!t.call(e, r, e) !== n;
      }) : t.nodeType ? T.grep(e, function (e) {
        return e === t !== n;
      }) : "string" != typeof t ? T.grep(e, function (e) {
        return f.call(t, e) > -1 !== n;
      }) : T.filter(t, e, n);
    }

    T.filter = function (e, t, n) {
      var r = t[0];
      return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? T.find.matchesSelector(r, e) ? [r] : [] : T.find.matches(e, T.grep(t, function (e) {
        return 1 === e.nodeType;
      }));
    }, T.fn.extend({
      find: function find(e) {
        var t,
            n,
            r = this.length,
            i = this;
        if ("string" != typeof e) return this.pushStack(T(e).filter(function () {
          for (t = 0; t < r; t++) {
            if (T.contains(i[t], this)) return !0;
          }
        }));

        for (n = this.pushStack([]), t = 0; t < r; t++) {
          T.find(e, i[t], n);
        }

        return r > 1 ? T.uniqueSort(n) : n;
      },
      filter: function filter(e) {
        return this.pushStack(q(this, e || [], !1));
      },
      not: function not(e) {
        return this.pushStack(q(this, e || [], !0));
      },
      is: function is(e) {
        return !!q(this, "string" == typeof e && A.test(e) ? T(e) : e || [], !1).length;
      }
    });
    var L,
        _ = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (T.fn.init = function (e, t, n) {
      var r, i;
      if (!e) return this;

      if (n = n || L, "string" == typeof e) {
        if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : _.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);

        if (r[1]) {
          if (t = t instanceof T ? t[0] : t, T.merge(this, T.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : s, !0)), O.test(r[1]) && T.isPlainObject(t)) for (r in t) {
            y(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
          }
          return this;
        }

        return (i = s.getElementById(r[2])) && (this[0] = i, this.length = 1), this;
      }

      return e.nodeType ? (this[0] = e, this.length = 1, this) : y(e) ? void 0 !== n.ready ? n.ready(e) : e(T) : T.makeArray(e, this);
    }).prototype = T.fn, L = T(s);
    var M = /^(?:parents|prev(?:Until|All))/,
        P = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };

    function I(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType;) {
        ;
      }

      return e;
    }

    T.fn.extend({
      has: function has(e) {
        var t = T(e, this),
            n = t.length;
        return this.filter(function () {
          for (var e = 0; e < n; e++) {
            if (T.contains(this, t[e])) return !0;
          }
        });
      },
      closest: function closest(e, t) {
        var n,
            r = 0,
            i = this.length,
            o = [],
            s = "string" != typeof e && T(e);
        if (!A.test(e)) for (; r < i; r++) {
          for (n = this[r]; n && n !== t; n = n.parentNode) {
            if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && T.find.matchesSelector(n, e))) {
              o.push(n);
              break;
            }
          }
        }
        return this.pushStack(o.length > 1 ? T.uniqueSort(o) : o);
      },
      index: function index(e) {
        return e ? "string" == typeof e ? f.call(T(e), this[0]) : f.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function add(e, t) {
        return this.pushStack(T.uniqueSort(T.merge(this.get(), T(e, t))));
      },
      addBack: function addBack(e) {
        return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
      }
    }), T.each({
      parent: function parent(e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null;
      },
      parents: function parents(e) {
        return j(e, "parentNode");
      },
      parentsUntil: function parentsUntil(e, t, n) {
        return j(e, "parentNode", n);
      },
      next: function next(e) {
        return I(e, "nextSibling");
      },
      prev: function prev(e) {
        return I(e, "previousSibling");
      },
      nextAll: function nextAll(e) {
        return j(e, "nextSibling");
      },
      prevAll: function prevAll(e) {
        return j(e, "previousSibling");
      },
      nextUntil: function nextUntil(e, t, n) {
        return j(e, "nextSibling", n);
      },
      prevUntil: function prevUntil(e, t, n) {
        return j(e, "previousSibling", n);
      },
      siblings: function siblings(e) {
        return D((e.parentNode || {}).firstChild, e);
      },
      children: function children(e) {
        return D(e.firstChild);
      },
      contents: function contents(e) {
        return void 0 !== e.contentDocument ? e.contentDocument : (N(e, "template") && (e = e.content || e), T.merge([], e.childNodes));
      }
    }, function (e, t) {
      T.fn[e] = function (n, r) {
        var i = T.map(this, t, n);
        return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = T.filter(r, i)), this.length > 1 && (P[e] || T.uniqueSort(i), M.test(e) && i.reverse()), this.pushStack(i);
      };
    });
    var H = /[^\x20\t\r\n\f]+/g;

    function $(e) {
      return e;
    }

    function R(e) {
      throw e;
    }

    function B(e, t, n, r) {
      var i;

      try {
        e && y(i = e.promise) ? i.call(e).done(t).fail(n) : e && y(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
      } catch (e) {
        n.apply(void 0, [e]);
      }
    }

    T.Callbacks = function (e) {
      e = "string" == typeof e ? function (e) {
        var t = {};
        return T.each(e.match(H) || [], function (e, n) {
          t[n] = !0;
        }), t;
      }(e) : T.extend({}, e);

      var t,
          n,
          r,
          i,
          o = [],
          s = [],
          a = -1,
          u = function u() {
        for (i = i || e.once, r = t = !0; s.length; a = -1) {
          for (n = s.shift(); ++a < o.length;) {
            !1 === o[a].apply(n[0], n[1]) && e.stopOnFalse && (a = o.length, n = !1);
          }
        }

        e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
      },
          c = {
        add: function add() {
          return o && (n && !t && (a = o.length - 1, s.push(n)), function t(n) {
            T.each(n, function (n, r) {
              y(r) ? e.unique && c.has(r) || o.push(r) : r && r.length && "string" !== C(r) && t(r);
            });
          }(arguments), n && !t && u()), this;
        },
        remove: function remove() {
          return T.each(arguments, function (e, t) {
            for (var n; (n = T.inArray(t, o, n)) > -1;) {
              o.splice(n, 1), n <= a && a--;
            }
          }), this;
        },
        has: function has(e) {
          return e ? T.inArray(e, o) > -1 : o.length > 0;
        },
        empty: function empty() {
          return o && (o = []), this;
        },
        disable: function disable() {
          return i = s = [], o = n = "", this;
        },
        disabled: function disabled() {
          return !o;
        },
        lock: function lock() {
          return i = s = [], n || t || (o = n = ""), this;
        },
        locked: function locked() {
          return !!i;
        },
        fireWith: function fireWith(e, n) {
          return i || (n = [e, (n = n || []).slice ? n.slice() : n], s.push(n), t || u()), this;
        },
        fire: function fire() {
          return c.fireWith(this, arguments), this;
        },
        fired: function fired() {
          return !!r;
        }
      };

      return c;
    }, T.extend({
      Deferred: function Deferred(e) {
        var t = [["notify", "progress", T.Callbacks("memory"), T.Callbacks("memory"), 2], ["resolve", "done", T.Callbacks("once memory"), T.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", T.Callbacks("once memory"), T.Callbacks("once memory"), 1, "rejected"]],
            r = "pending",
            i = {
          state: function state() {
            return r;
          },
          always: function always() {
            return o.done(arguments).fail(arguments), this;
          },
          catch: function _catch(e) {
            return i.then(null, e);
          },
          pipe: function pipe() {
            var e = arguments;
            return T.Deferred(function (n) {
              T.each(t, function (t, r) {
                var i = y(e[r[4]]) && e[r[4]];
                o[r[1]](function () {
                  var e = i && i.apply(this, arguments);
                  e && y(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this, i ? [e] : arguments);
                });
              }), e = null;
            }).promise();
          },
          then: function then(e, r, i) {
            var o = 0;

            function s(e, t, r, i) {
              return function () {
                var a = this,
                    u = arguments,
                    c = function c() {
                  var n, c;

                  if (!(e < o)) {
                    if ((n = r.apply(a, u)) === t.promise()) throw new TypeError("Thenable self-resolution");
                    c = n && ("object" == _typeof(n) || "function" == typeof n) && n.then, y(c) ? i ? c.call(n, s(o, t, $, i), s(o, t, R, i)) : (o++, c.call(n, s(o, t, $, i), s(o, t, R, i), s(o, t, $, t.notifyWith))) : (r !== $ && (a = void 0, u = [n]), (i || t.resolveWith)(a, u));
                  }
                },
                    l = i ? c : function () {
                  try {
                    c();
                  } catch (n) {
                    T.Deferred.exceptionHook && T.Deferred.exceptionHook(n, l.stackTrace), e + 1 >= o && (r !== R && (a = void 0, u = [n]), t.rejectWith(a, u));
                  }
                };

                e ? l() : (T.Deferred.getStackHook && (l.stackTrace = T.Deferred.getStackHook()), n.setTimeout(l));
              };
            }

            return T.Deferred(function (n) {
              t[0][3].add(s(0, n, y(i) ? i : $, n.notifyWith)), t[1][3].add(s(0, n, y(e) ? e : $)), t[2][3].add(s(0, n, y(r) ? r : R));
            }).promise();
          },
          promise: function promise(e) {
            return null != e ? T.extend(e, i) : i;
          }
        },
            o = {};
        return T.each(t, function (e, n) {
          var s = n[2],
              a = n[5];
          i[n[1]] = s.add, a && s.add(function () {
            r = a;
          }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), s.add(n[3].fire), o[n[0]] = function () {
            return o[n[0] + "With"](this === o ? void 0 : this, arguments), this;
          }, o[n[0] + "With"] = s.fireWith;
        }), i.promise(o), e && e.call(o, o), o;
      },
      when: function when(e) {
        var t = arguments.length,
            n = t,
            r = Array(n),
            i = u.call(arguments),
            o = T.Deferred(),
            s = function s(e) {
          return function (n) {
            r[e] = this, i[e] = arguments.length > 1 ? u.call(arguments) : n, --t || o.resolveWith(r, i);
          };
        };

        if (t <= 1 && (B(e, o.done(s(n)).resolve, o.reject, !t), "pending" === o.state() || y(i[n] && i[n].then))) return o.then();

        for (; n--;) {
          B(i[n], s(n), o.reject);
        }

        return o.promise();
      }
    });
    var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    T.Deferred.exceptionHook = function (e, t) {
      n.console && n.console.warn && e && W.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
    }, T.readyException = function (e) {
      n.setTimeout(function () {
        throw e;
      });
    };
    var F = T.Deferred();

    function z() {
      s.removeEventListener("DOMContentLoaded", z), n.removeEventListener("load", z), T.ready();
    }

    T.fn.ready = function (e) {
      return F.then(e).catch(function (e) {
        T.readyException(e);
      }), this;
    }, T.extend({
      isReady: !1,
      readyWait: 1,
      ready: function ready(e) {
        (!0 === e ? --T.readyWait : T.isReady) || (T.isReady = !0, !0 !== e && --T.readyWait > 0 || F.resolveWith(s, [T]));
      }
    }), T.ready.then = F.then, "complete" === s.readyState || "loading" !== s.readyState && !s.documentElement.doScroll ? n.setTimeout(T.ready) : (s.addEventListener("DOMContentLoaded", z), n.addEventListener("load", z));

    var U = function U(e, t, n, r, i, o, s) {
      var a = 0,
          u = e.length,
          c = null == n;
      if ("object" === C(n)) for (a in i = !0, n) {
        U(e, t, a, n[a], !0, o, s);
      } else if (void 0 !== r && (i = !0, y(r) || (s = !0), c && (s ? (t.call(e, r), t = null) : (c = t, t = function t(e, _t2, n) {
        return c.call(T(e), n);
      })), t)) for (; a < u; a++) {
        t(e[a], n, s ? r : r.call(e[a], a, t(e[a], n)));
      }
      return i ? e : c ? t.call(e) : u ? t(e[0], n) : o;
    },
        X = /^-ms-/,
        Q = /-([a-z])/g;

    function V(e, t) {
      return t.toUpperCase();
    }

    function G(e) {
      return e.replace(X, "ms-").replace(Q, V);
    }

    var Y = function Y(e) {
      return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };

    function J() {
      this.expando = T.expando + J.uid++;
    }

    J.uid = 1, J.prototype = {
      cache: function cache(e) {
        var t = e[this.expando];
        return t || (t = {}, Y(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
          value: t,
          configurable: !0
        }))), t;
      },
      set: function set(e, t, n) {
        var r,
            i = this.cache(e);
        if ("string" == typeof t) i[G(t)] = n;else for (r in t) {
          i[G(r)] = t[r];
        }
        return i;
      },
      get: function get(e, t) {
        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
      },
      access: function access(e, t, n) {
        return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function remove(e, t) {
        var n,
            r = e[this.expando];

        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(H) || []).length;

            for (; n--;) {
              delete r[t[n]];
            }
          }

          (void 0 === t || T.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
        }
      },
      hasData: function hasData(e) {
        var t = e[this.expando];
        return void 0 !== t && !T.isEmptyObject(t);
      }
    };
    var K = new J(),
        Z = new J(),
        ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        te = /[A-Z]/g;

    function ne(e, t, n) {
      var r;
      if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(te, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
        try {
          n = function (e) {
            return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e);
          }(n);
        } catch (e) {}

        Z.set(e, t, n);
      } else n = void 0;
      return n;
    }

    T.extend({
      hasData: function hasData(e) {
        return Z.hasData(e) || K.hasData(e);
      },
      data: function data(e, t, n) {
        return Z.access(e, t, n);
      },
      removeData: function removeData(e, t) {
        Z.remove(e, t);
      },
      _data: function _data(e, t, n) {
        return K.access(e, t, n);
      },
      _removeData: function _removeData(e, t) {
        K.remove(e, t);
      }
    }), T.fn.extend({
      data: function data(e, t) {
        var n,
            r,
            i,
            o = this[0],
            s = o && o.attributes;

        if (void 0 === e) {
          if (this.length && (i = Z.get(o), 1 === o.nodeType && !K.get(o, "hasDataAttrs"))) {
            for (n = s.length; n--;) {
              s[n] && 0 === (r = s[n].name).indexOf("data-") && (r = G(r.slice(5)), ne(o, r, i[r]));
            }

            K.set(o, "hasDataAttrs", !0);
          }

          return i;
        }

        return "object" == _typeof(e) ? this.each(function () {
          Z.set(this, e);
        }) : U(this, function (t) {
          var n;
          if (o && void 0 === t) return void 0 !== (n = Z.get(o, e)) ? n : void 0 !== (n = ne(o, e)) ? n : void 0;
          this.each(function () {
            Z.set(this, e, t);
          });
        }, null, t, arguments.length > 1, null, !0);
      },
      removeData: function removeData(e) {
        return this.each(function () {
          Z.remove(this, e);
        });
      }
    }), T.extend({
      queue: function queue(e, t, n) {
        var r;
        if (e) return t = (t || "fx") + "queue", r = K.get(e, t), n && (!r || Array.isArray(n) ? r = K.access(e, t, T.makeArray(n)) : r.push(n)), r || [];
      },
      dequeue: function dequeue(e, t) {
        t = t || "fx";

        var n = T.queue(e, t),
            r = n.length,
            i = n.shift(),
            o = T._queueHooks(e, t);

        "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function () {
          T.dequeue(e, t);
        }, o)), !r && o && o.empty.fire();
      },
      _queueHooks: function _queueHooks(e, t) {
        var n = t + "queueHooks";
        return K.get(e, n) || K.access(e, n, {
          empty: T.Callbacks("once memory").add(function () {
            K.remove(e, [t + "queue", n]);
          })
        });
      }
    }), T.fn.extend({
      queue: function queue(e, t) {
        var n = 2;
        return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? T.queue(this[0], e) : void 0 === t ? this : this.each(function () {
          var n = T.queue(this, e, t);
          T._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && T.dequeue(this, e);
        });
      },
      dequeue: function dequeue(e) {
        return this.each(function () {
          T.dequeue(this, e);
        });
      },
      clearQueue: function clearQueue(e) {
        return this.queue(e || "fx", []);
      },
      promise: function promise(e, t) {
        var n,
            r = 1,
            i = T.Deferred(),
            o = this,
            s = this.length,
            a = function a() {
          --r || i.resolveWith(o, [o]);
        };

        for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;) {
          (n = K.get(o[s], e + "queueHooks")) && n.empty && (r++, n.empty.add(a));
        }

        return a(), i.promise(t);
      }
    });

    var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
        oe = ["Top", "Right", "Bottom", "Left"],
        se = s.documentElement,
        ae = function ae(e) {
      return T.contains(e.ownerDocument, e);
    },
        ue = {
      composed: !0
    };

    se.getRootNode && (ae = function ae(e) {
      return T.contains(e.ownerDocument, e) || e.getRootNode(ue) === e.ownerDocument;
    });

    var ce = function ce(e, t) {
      return "none" === (e = t || e).style.display || "" === e.style.display && ae(e) && "none" === T.css(e, "display");
    },
        le = function le(e, t, n, r) {
      var i,
          o,
          s = {};

      for (o in t) {
        s[o] = e.style[o], e.style[o] = t[o];
      }

      for (o in i = n.apply(e, r || []), t) {
        e.style[o] = s[o];
      }

      return i;
    };

    function fe(e, t, n, r) {
      var i,
          o,
          s = 20,
          a = r ? function () {
        return r.cur();
      } : function () {
        return T.css(e, t, "");
      },
          u = a(),
          c = n && n[3] || (T.cssNumber[t] ? "" : "px"),
          l = e.nodeType && (T.cssNumber[t] || "px" !== c && +u) && ie.exec(T.css(e, t));

      if (l && l[3] !== c) {
        for (u /= 2, c = c || l[3], l = +u || 1; s--;) {
          T.style(e, t, l + c), (1 - o) * (1 - (o = a() / u || .5)) <= 0 && (s = 0), l /= o;
        }

        l *= 2, T.style(e, t, l + c), n = n || [];
      }

      return n && (l = +l || +u || 0, i = n[1] ? l + (n[1] + 1) * n[2] : +n[2], r && (r.unit = c, r.start = l, r.end = i)), i;
    }

    var de = {};

    function pe(e) {
      var t,
          n = e.ownerDocument,
          r = e.nodeName,
          i = de[r];
      return i || (t = n.body.appendChild(n.createElement(r)), i = T.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), de[r] = i, i);
    }

    function he(e, t) {
      for (var n, r, i = [], o = 0, s = e.length; o < s; o++) {
        (r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = K.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ce(r) && (i[o] = pe(r))) : "none" !== n && (i[o] = "none", K.set(r, "display", n)));
      }

      for (o = 0; o < s; o++) {
        null != i[o] && (e[o].style.display = i[o]);
      }

      return e;
    }

    T.fn.extend({
      show: function show() {
        return he(this, !0);
      },
      hide: function hide() {
        return he(this);
      },
      toggle: function toggle(e) {
        return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
          ce(this) ? T(this).show() : T(this).hide();
        });
      }
    });
    var ge = /^(?:checkbox|radio)$/i,
        ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        me = /^$|^module$|\/(?:java|ecma)script/i,
        ye = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };

    function xe(e, t) {
      var n;
      return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && N(e, t) ? T.merge([e], n) : n;
    }

    function be(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        K.set(e[n], "globalEval", !t || K.get(t[n], "globalEval"));
      }
    }

    ye.optgroup = ye.option, ye.tbody = ye.tfoot = ye.colgroup = ye.caption = ye.thead, ye.th = ye.td;
    var we,
        Ce,
        Te = /<|&#?\w+;/;

    function ke(e, t, n, r, i) {
      for (var o, s, a, u, c, l, f = t.createDocumentFragment(), d = [], p = 0, h = e.length; p < h; p++) {
        if ((o = e[p]) || 0 === o) if ("object" === C(o)) T.merge(d, o.nodeType ? [o] : o);else if (Te.test(o)) {
          for (s = s || f.appendChild(t.createElement("div")), a = (ve.exec(o) || ["", ""])[1].toLowerCase(), u = ye[a] || ye._default, s.innerHTML = u[1] + T.htmlPrefilter(o) + u[2], l = u[0]; l--;) {
            s = s.lastChild;
          }

          T.merge(d, s.childNodes), (s = f.firstChild).textContent = "";
        } else d.push(t.createTextNode(o));
      }

      for (f.textContent = "", p = 0; o = d[p++];) {
        if (r && T.inArray(o, r) > -1) i && i.push(o);else if (c = ae(o), s = xe(f.appendChild(o), "script"), c && be(s), n) for (l = 0; o = s[l++];) {
          me.test(o.type || "") && n.push(o);
        }
      }

      return f;
    }

    we = s.createDocumentFragment().appendChild(s.createElement("div")), (Ce = s.createElement("input")).setAttribute("type", "radio"), Ce.setAttribute("checked", "checked"), Ce.setAttribute("name", "t"), we.appendChild(Ce), m.checkClone = we.cloneNode(!0).cloneNode(!0).lastChild.checked, we.innerHTML = "<textarea>x</textarea>", m.noCloneChecked = !!we.cloneNode(!0).lastChild.defaultValue;
    var Se = /^key/,
        Ee = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        je = /^([^.]*)(?:\.(.+)|)/;

    function De() {
      return !0;
    }

    function Ae() {
      return !1;
    }

    function Ne(e, t) {
      return e === function () {
        try {
          return s.activeElement;
        } catch (e) {}
      }() == ("focus" === t);
    }

    function Oe(e, t, n, r, i, o) {
      var s, a;

      if ("object" == _typeof(t)) {
        for (a in "string" != typeof n && (r = r || n, n = void 0), t) {
          Oe(e, a, n, r, t[a], o);
        }

        return e;
      }

      if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Ae;else if (!i) return e;
      return 1 === o && (s = i, (i = function i(e) {
        return T().off(e), s.apply(this, arguments);
      }).guid = s.guid || (s.guid = T.guid++)), e.each(function () {
        T.event.add(this, t, i, r, n);
      });
    }

    function qe(e, t, n) {
      n ? (K.set(e, t, !1), T.event.add(e, t, {
        namespace: !1,
        handler: function handler(e) {
          var r,
              i,
              o = K.get(this, t);

          if (1 & e.isTrigger && this[t]) {
            if (o.length) (T.event.special[t] || {}).delegateType && e.stopPropagation();else if (o = u.call(arguments), K.set(this, t, o), r = n(this, t), this[t](), o !== (i = K.get(this, t)) || r ? K.set(this, t, !1) : i = {}, o !== i) return e.stopImmediatePropagation(), e.preventDefault(), i.value;
          } else o.length && (K.set(this, t, {
            value: T.event.trigger(T.extend(o[0], T.Event.prototype), o.slice(1), this)
          }), e.stopImmediatePropagation());
        }
      })) : void 0 === K.get(e, t) && T.event.add(e, t, De);
    }

    T.event = {
      global: {},
      add: function add(e, t, n, r, i) {
        var o,
            s,
            a,
            u,
            c,
            l,
            f,
            d,
            p,
            h,
            g,
            v = K.get(e);
        if (v) for (n.handler && (n = (o = n).handler, i = o.selector), i && T.find.matchesSelector(se, i), n.guid || (n.guid = T.guid++), (u = v.events) || (u = v.events = {}), (s = v.handle) || (s = v.handle = function (t) {
          return void 0 !== T && T.event.triggered !== t.type ? T.event.dispatch.apply(e, arguments) : void 0;
        }), c = (t = (t || "").match(H) || [""]).length; c--;) {
          p = g = (a = je.exec(t[c]) || [])[1], h = (a[2] || "").split(".").sort(), p && (f = T.event.special[p] || {}, p = (i ? f.delegateType : f.bindType) || p, f = T.event.special[p] || {}, l = T.extend({
            type: p,
            origType: g,
            data: r,
            handler: n,
            guid: n.guid,
            selector: i,
            needsContext: i && T.expr.match.needsContext.test(i),
            namespace: h.join(".")
          }, o), (d = u[p]) || ((d = u[p] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, s) || e.addEventListener && e.addEventListener(p, s)), f.add && (f.add.call(e, l), l.handler.guid || (l.handler.guid = n.guid)), i ? d.splice(d.delegateCount++, 0, l) : d.push(l), T.event.global[p] = !0);
        }
      },
      remove: function remove(e, t, n, r, i) {
        var o,
            s,
            a,
            u,
            c,
            l,
            f,
            d,
            p,
            h,
            g,
            v = K.hasData(e) && K.get(e);

        if (v && (u = v.events)) {
          for (c = (t = (t || "").match(H) || [""]).length; c--;) {
            if (p = g = (a = je.exec(t[c]) || [])[1], h = (a[2] || "").split(".").sort(), p) {
              for (f = T.event.special[p] || {}, d = u[p = (r ? f.delegateType : f.bindType) || p] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = d.length; o--;) {
                l = d[o], !i && g !== l.origType || n && n.guid !== l.guid || a && !a.test(l.namespace) || r && r !== l.selector && ("**" !== r || !l.selector) || (d.splice(o, 1), l.selector && d.delegateCount--, f.remove && f.remove.call(e, l));
              }

              s && !d.length && (f.teardown && !1 !== f.teardown.call(e, h, v.handle) || T.removeEvent(e, p, v.handle), delete u[p]);
            } else for (p in u) {
              T.event.remove(e, p + t[c], n, r, !0);
            }
          }

          T.isEmptyObject(u) && K.remove(e, "handle events");
        }
      },
      dispatch: function dispatch(e) {
        var t,
            n,
            r,
            i,
            o,
            s,
            a = T.event.fix(e),
            u = new Array(arguments.length),
            c = (K.get(this, "events") || {})[a.type] || [],
            l = T.event.special[a.type] || {};

        for (u[0] = a, t = 1; t < arguments.length; t++) {
          u[t] = arguments[t];
        }

        if (a.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, a)) {
          for (s = T.event.handlers.call(this, a, c), t = 0; (i = s[t++]) && !a.isPropagationStopped();) {
            for (a.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !a.isImmediatePropagationStopped();) {
              a.rnamespace && !1 !== o.namespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o, a.data = o.data, void 0 !== (r = ((T.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, u)) && !1 === (a.result = r) && (a.preventDefault(), a.stopPropagation()));
            }
          }

          return l.postDispatch && l.postDispatch.call(this, a), a.result;
        }
      },
      handlers: function handlers(e, t) {
        var n,
            r,
            i,
            o,
            s,
            a = [],
            u = t.delegateCount,
            c = e.target;
        if (u && c.nodeType && !("click" === e.type && e.button >= 1)) for (; c !== this; c = c.parentNode || this) {
          if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
            for (o = [], s = {}, n = 0; n < u; n++) {
              void 0 === s[i = (r = t[n]).selector + " "] && (s[i] = r.needsContext ? T(i, this).index(c) > -1 : T.find(i, this, null, [c]).length), s[i] && o.push(r);
            }

            o.length && a.push({
              elem: c,
              handlers: o
            });
          }
        }
        return c = this, u < t.length && a.push({
          elem: c,
          handlers: t.slice(u)
        }), a;
      },
      addProp: function addProp(e, t) {
        Object.defineProperty(T.Event.prototype, e, {
          enumerable: !0,
          configurable: !0,
          get: y(t) ? function () {
            if (this.originalEvent) return t(this.originalEvent);
          } : function () {
            if (this.originalEvent) return this.originalEvent[e];
          },
          set: function set(t) {
            Object.defineProperty(this, e, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: t
            });
          }
        });
      },
      fix: function fix(e) {
        return e[T.expando] ? e : new T.Event(e);
      },
      special: {
        load: {
          noBubble: !0
        },
        click: {
          setup: function setup(e) {
            var t = this || e;
            return ge.test(t.type) && t.click && N(t, "input") && qe(t, "click", De), !1;
          },
          trigger: function trigger(e) {
            var t = this || e;
            return ge.test(t.type) && t.click && N(t, "input") && qe(t, "click"), !0;
          },
          _default: function _default(e) {
            var t = e.target;
            return ge.test(t.type) && t.click && N(t, "input") && K.get(t, "click") || N(t, "a");
          }
        },
        beforeunload: {
          postDispatch: function postDispatch(e) {
            void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
          }
        }
      }
    }, T.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }, T.Event = function (e, t) {
      if (!(this instanceof T.Event)) return new T.Event(e, t);
      e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? De : Ae, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && T.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[T.expando] = !0;
    }, T.Event.prototype = {
      constructor: T.Event,
      isDefaultPrevented: Ae,
      isPropagationStopped: Ae,
      isImmediatePropagationStopped: Ae,
      isSimulated: !1,
      preventDefault: function preventDefault() {
        var e = this.originalEvent;
        this.isDefaultPrevented = De, e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function stopPropagation() {
        var e = this.originalEvent;
        this.isPropagationStopped = De, e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function stopImmediatePropagation() {
        var e = this.originalEvent;
        this.isImmediatePropagationStopped = De, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
      }
    }, T.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: function which(e) {
        var t = e.button;
        return null == e.which && Se.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Ee.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which;
      }
    }, T.event.addProp), T.each({
      focus: "focusin",
      blur: "focusout"
    }, function (e, t) {
      T.event.special[e] = {
        setup: function setup() {
          return qe(this, e, Ne), !1;
        },
        trigger: function trigger() {
          return qe(this, e), !0;
        },
        delegateType: t
      };
    }), T.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function (e, t) {
      T.event.special[e] = {
        delegateType: t,
        bindType: t,
        handle: function handle(e) {
          var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj;
          return i && (i === r || T.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
        }
      };
    }), T.fn.extend({
      on: function on(e, t, n, r) {
        return Oe(this, e, t, n, r);
      },
      one: function one(e, t, n, r) {
        return Oe(this, e, t, n, r, 1);
      },
      off: function off(e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj) return r = e.handleObj, T(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;

        if ("object" == _typeof(e)) {
          for (i in e) {
            this.off(i, t, e[i]);
          }

          return this;
        }

        return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Ae), this.each(function () {
          T.event.remove(this, e, n, t);
        });
      }
    });
    var Le = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
        _e = /<script|<style|<link/i,
        Me = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Pe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function Ie(e, t) {
      return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr") && T(e).children("tbody")[0] || e;
    }

    function He(e) {
      return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
    }

    function $e(e) {
      return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
    }

    function Re(e, t) {
      var n, r, i, o, s, a, u, c;

      if (1 === t.nodeType) {
        if (K.hasData(e) && (o = K.access(e), s = K.set(t, o), c = o.events)) for (i in delete s.handle, s.events = {}, c) {
          for (n = 0, r = c[i].length; n < r; n++) {
            T.event.add(t, i, c[i][n]);
          }
        }
        Z.hasData(e) && (a = Z.access(e), u = T.extend({}, a), Z.set(t, u));
      }
    }

    function Be(e, t) {
      var n = t.nodeName.toLowerCase();
      "input" === n && ge.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
    }

    function We(e, t, n, r) {
      t = c.apply([], t);
      var i,
          o,
          s,
          a,
          u,
          l,
          f = 0,
          d = e.length,
          p = d - 1,
          h = t[0],
          g = y(h);
      if (g || d > 1 && "string" == typeof h && !m.checkClone && Me.test(h)) return e.each(function (i) {
        var o = e.eq(i);
        g && (t[0] = h.call(this, i, o.html())), We(o, t, n, r);
      });

      if (d && (o = (i = ke(t, e[0].ownerDocument, !1, e, r)).firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
        for (a = (s = T.map(xe(i, "script"), He)).length; f < d; f++) {
          u = i, f !== p && (u = T.clone(u, !0, !0), a && T.merge(s, xe(u, "script"))), n.call(e[f], u, f);
        }

        if (a) for (l = s[s.length - 1].ownerDocument, T.map(s, $e), f = 0; f < a; f++) {
          u = s[f], me.test(u.type || "") && !K.access(u, "globalEval") && T.contains(l, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? T._evalUrl && !u.noModule && T._evalUrl(u.src, {
            nonce: u.nonce || u.getAttribute("nonce")
          }) : w(u.textContent.replace(Pe, ""), u, l));
        }
      }

      return e;
    }

    function Fe(e, t, n) {
      for (var r, i = t ? T.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
        n || 1 !== r.nodeType || T.cleanData(xe(r)), r.parentNode && (n && ae(r) && be(xe(r, "script")), r.parentNode.removeChild(r));
      }

      return e;
    }

    T.extend({
      htmlPrefilter: function htmlPrefilter(e) {
        return e.replace(Le, "<$1></$2>");
      },
      clone: function clone(e, t, n) {
        var r,
            i,
            o,
            s,
            a = e.cloneNode(!0),
            u = ae(e);
        if (!(m.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || T.isXMLDoc(e))) for (s = xe(a), r = 0, i = (o = xe(e)).length; r < i; r++) {
          Be(o[r], s[r]);
        }
        if (t) if (n) for (o = o || xe(e), s = s || xe(a), r = 0, i = o.length; r < i; r++) {
          Re(o[r], s[r]);
        } else Re(e, a);
        return (s = xe(a, "script")).length > 0 && be(s, !u && xe(e, "script")), a;
      },
      cleanData: function cleanData(e) {
        for (var t, n, r, i = T.event.special, o = 0; void 0 !== (n = e[o]); o++) {
          if (Y(n)) {
            if (t = n[K.expando]) {
              if (t.events) for (r in t.events) {
                i[r] ? T.event.remove(n, r) : T.removeEvent(n, r, t.handle);
              }
              n[K.expando] = void 0;
            }

            n[Z.expando] && (n[Z.expando] = void 0);
          }
        }
      }
    }), T.fn.extend({
      detach: function detach(e) {
        return Fe(this, e, !0);
      },
      remove: function remove(e) {
        return Fe(this, e);
      },
      text: function text(e) {
        return U(this, function (e) {
          return void 0 === e ? T.text(this) : this.empty().each(function () {
            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
          });
        }, null, e, arguments.length);
      },
      append: function append() {
        return We(this, arguments, function (e) {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Ie(this, e).appendChild(e);
        });
      },
      prepend: function prepend() {
        return We(this, arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Ie(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function before() {
        return We(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function after() {
        return We(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function empty() {
        for (var e, t = 0; null != (e = this[t]); t++) {
          1 === e.nodeType && (T.cleanData(xe(e, !1)), e.textContent = "");
        }

        return this;
      },
      clone: function clone(e, t) {
        return e = null != e && e, t = null == t ? e : t, this.map(function () {
          return T.clone(this, e, t);
        });
      },
      html: function html(e) {
        return U(this, function (e) {
          var t = this[0] || {},
              n = 0,
              r = this.length;
          if (void 0 === e && 1 === t.nodeType) return t.innerHTML;

          if ("string" == typeof e && !_e.test(e) && !ye[(ve.exec(e) || ["", ""])[1].toLowerCase()]) {
            e = T.htmlPrefilter(e);

            try {
              for (; n < r; n++) {
                1 === (t = this[n] || {}).nodeType && (T.cleanData(xe(t, !1)), t.innerHTML = e);
              }

              t = 0;
            } catch (e) {}
          }

          t && this.empty().append(e);
        }, null, e, arguments.length);
      },
      replaceWith: function replaceWith() {
        var e = [];
        return We(this, arguments, function (t) {
          var n = this.parentNode;
          T.inArray(this, e) < 0 && (T.cleanData(xe(this)), n && n.replaceChild(t, this));
        }, e);
      }
    }), T.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function (e, t) {
      T.fn[e] = function (e) {
        for (var n, r = [], i = T(e), o = i.length - 1, s = 0; s <= o; s++) {
          n = s === o ? this : this.clone(!0), T(i[s])[t](n), l.apply(r, n.get());
        }

        return this.pushStack(r);
      };
    });

    var ze = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
        Ue = function Ue(e) {
      var t = e.ownerDocument.defaultView;
      return t && t.opener || (t = n), t.getComputedStyle(e);
    },
        Xe = new RegExp(oe.join("|"), "i");

    function Qe(e, t, n) {
      var r,
          i,
          o,
          s,
          a = e.style;
      return (n = n || Ue(e)) && ("" !== (s = n.getPropertyValue(t) || n[t]) || ae(e) || (s = T.style(e, t)), !m.pixelBoxStyles() && ze.test(s) && Xe.test(t) && (r = a.width, i = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = r, a.minWidth = i, a.maxWidth = o)), void 0 !== s ? s + "" : s;
    }

    function Ve(e, t) {
      return {
        get: function get() {
          if (!e()) return (this.get = t).apply(this, arguments);
          delete this.get;
        }
      };
    }

    !function () {
      function e() {
        if (l) {
          c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", se.appendChild(c).appendChild(l);
          var e = n.getComputedStyle(l);
          r = "1%" !== e.top, u = 12 === t(e.marginLeft), l.style.right = "60%", a = 36 === t(e.right), i = 36 === t(e.width), l.style.position = "absolute", o = 12 === t(l.offsetWidth / 3), se.removeChild(c), l = null;
        }
      }

      function t(e) {
        return Math.round(parseFloat(e));
      }

      var r,
          i,
          o,
          a,
          u,
          c = s.createElement("div"),
          l = s.createElement("div");
      l.style && (l.style.backgroundClip = "content-box", l.cloneNode(!0).style.backgroundClip = "", m.clearCloneStyle = "content-box" === l.style.backgroundClip, T.extend(m, {
        boxSizingReliable: function boxSizingReliable() {
          return e(), i;
        },
        pixelBoxStyles: function pixelBoxStyles() {
          return e(), a;
        },
        pixelPosition: function pixelPosition() {
          return e(), r;
        },
        reliableMarginLeft: function reliableMarginLeft() {
          return e(), u;
        },
        scrollboxSize: function scrollboxSize() {
          return e(), o;
        }
      }));
    }();
    var Ge = ["Webkit", "Moz", "ms"],
        Ye = s.createElement("div").style,
        Je = {};

    function Ke(e) {
      var t = T.cssProps[e] || Je[e];
      return t || (e in Ye ? e : Je[e] = function (e) {
        for (var t = e[0].toUpperCase() + e.slice(1), n = Ge.length; n--;) {
          if ((e = Ge[n] + t) in Ye) return e;
        }
      }(e) || e);
    }

    var Ze = /^(none|table(?!-c[ea]).+)/,
        et = /^--/,
        tt = {
      position: "absolute",
      visibility: "hidden",
      display: "block"
    },
        nt = {
      letterSpacing: "0",
      fontWeight: "400"
    };

    function rt(e, t, n) {
      var r = ie.exec(t);
      return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
    }

    function it(e, t, n, r, i, o) {
      var s = "width" === t ? 1 : 0,
          a = 0,
          u = 0;
      if (n === (r ? "border" : "content")) return 0;

      for (; s < 4; s += 2) {
        "margin" === n && (u += T.css(e, n + oe[s], !0, i)), r ? ("content" === n && (u -= T.css(e, "padding" + oe[s], !0, i)), "margin" !== n && (u -= T.css(e, "border" + oe[s] + "Width", !0, i))) : (u += T.css(e, "padding" + oe[s], !0, i), "padding" !== n ? u += T.css(e, "border" + oe[s] + "Width", !0, i) : a += T.css(e, "border" + oe[s] + "Width", !0, i));
      }

      return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - a - .5)) || 0), u;
    }

    function ot(e, t, n) {
      var r = Ue(e),
          i = (!m.boxSizingReliable() || n) && "border-box" === T.css(e, "boxSizing", !1, r),
          o = i,
          s = Qe(e, t, r),
          a = "offset" + t[0].toUpperCase() + t.slice(1);

      if (ze.test(s)) {
        if (!n) return s;
        s = "auto";
      }

      return (!m.boxSizingReliable() && i || "auto" === s || !parseFloat(s) && "inline" === T.css(e, "display", !1, r)) && e.getClientRects().length && (i = "border-box" === T.css(e, "boxSizing", !1, r), (o = a in e) && (s = e[a])), (s = parseFloat(s) || 0) + it(e, t, n || (i ? "border" : "content"), o, r, s) + "px";
    }

    function st(e, t, n, r, i) {
      return new st.prototype.init(e, t, n, r, i);
    }

    T.extend({
      cssHooks: {
        opacity: {
          get: function get(e, t) {
            if (t) {
              var n = Qe(e, "opacity");
              return "" === n ? "1" : n;
            }
          }
        }
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0
      },
      cssProps: {},
      style: function style(e, t, n, r) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var i,
              o,
              s,
              a = G(t),
              u = et.test(t),
              c = e.style;
          if (u || (t = Ke(a)), s = T.cssHooks[t] || T.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (i = s.get(e, !1, r)) ? i : c[t];
          "string" === (o = _typeof(n)) && (i = ie.exec(n)) && i[1] && (n = fe(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (T.cssNumber[a] ? "" : "px")), m.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, r)) || (u ? c.setProperty(t, n) : c[t] = n));
        }
      },
      css: function css(e, t, n, r) {
        var i,
            o,
            s,
            a = G(t);
        return et.test(t) || (t = Ke(a)), (s = T.cssHooks[t] || T.cssHooks[a]) && "get" in s && (i = s.get(e, !0, n)), void 0 === i && (i = Qe(e, t, r)), "normal" === i && t in nt && (i = nt[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
      }
    }), T.each(["height", "width"], function (e, t) {
      T.cssHooks[t] = {
        get: function get(e, n, r) {
          if (n) return !Ze.test(T.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ot(e, t, r) : le(e, tt, function () {
            return ot(e, t, r);
          });
        },
        set: function set(e, n, r) {
          var i,
              o = Ue(e),
              s = !m.scrollboxSize() && "absolute" === o.position,
              a = (s || r) && "border-box" === T.css(e, "boxSizing", !1, o),
              u = r ? it(e, t, r, a, o) : 0;
          return a && s && (u -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - it(e, t, "border", !1, o) - .5)), u && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = T.css(e, t)), rt(0, n, u);
        }
      };
    }), T.cssHooks.marginLeft = Ve(m.reliableMarginLeft, function (e, t) {
      if (t) return (parseFloat(Qe(e, "marginLeft")) || e.getBoundingClientRect().left - le(e, {
        marginLeft: 0
      }, function () {
        return e.getBoundingClientRect().left;
      })) + "px";
    }), T.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function (e, t) {
      T.cssHooks[e + t] = {
        expand: function expand(n) {
          for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) {
            i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
          }

          return i;
        }
      }, "margin" !== e && (T.cssHooks[e + t].set = rt);
    }), T.fn.extend({
      css: function css(e, t) {
        return U(this, function (e, t, n) {
          var r,
              i,
              o = {},
              s = 0;

          if (Array.isArray(t)) {
            for (r = Ue(e), i = t.length; s < i; s++) {
              o[t[s]] = T.css(e, t[s], !1, r);
            }

            return o;
          }

          return void 0 !== n ? T.style(e, t, n) : T.css(e, t);
        }, e, t, arguments.length > 1);
      }
    }), T.Tween = st, st.prototype = {
      constructor: st,
      init: function init(e, t, n, r, i, o) {
        this.elem = e, this.prop = n, this.easing = i || T.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (T.cssNumber[n] ? "" : "px");
      },
      cur: function cur() {
        var e = st.propHooks[this.prop];
        return e && e.get ? e.get(this) : st.propHooks._default.get(this);
      },
      run: function run(e) {
        var t,
            n = st.propHooks[this.prop];
        return this.options.duration ? this.pos = t = T.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : st.propHooks._default.set(this), this;
      }
    }, st.prototype.init.prototype = st.prototype, st.propHooks = {
      _default: {
        get: function get(e) {
          var t;
          return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = T.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
        },
        set: function set(e) {
          T.fx.step[e.prop] ? T.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !T.cssHooks[e.prop] && null == e.elem.style[Ke(e.prop)] ? e.elem[e.prop] = e.now : T.style(e.elem, e.prop, e.now + e.unit);
        }
      }
    }, st.propHooks.scrollTop = st.propHooks.scrollLeft = {
      set: function set(e) {
        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
      }
    }, T.easing = {
      linear: function linear(e) {
        return e;
      },
      swing: function swing(e) {
        return .5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing"
    }, T.fx = st.prototype.init, T.fx.step = {};
    var at,
        ut,
        ct = /^(?:toggle|show|hide)$/,
        lt = /queueHooks$/;

    function ft() {
      ut && (!1 === s.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(ft) : n.setTimeout(ft, T.fx.interval), T.fx.tick());
    }

    function dt() {
      return n.setTimeout(function () {
        at = void 0;
      }), at = Date.now();
    }

    function pt(e, t) {
      var n,
          r = 0,
          i = {
        height: e
      };

      for (t = t ? 1 : 0; r < 4; r += 2 - t) {
        i["margin" + (n = oe[r])] = i["padding" + n] = e;
      }

      return t && (i.opacity = i.width = e), i;
    }

    function ht(e, t, n) {
      for (var r, i = (gt.tweeners[t] || []).concat(gt.tweeners["*"]), o = 0, s = i.length; o < s; o++) {
        if (r = i[o].call(n, t, e)) return r;
      }
    }

    function gt(e, t, n) {
      var r,
          i,
          o = 0,
          s = gt.prefilters.length,
          a = T.Deferred().always(function () {
        delete u.elem;
      }),
          u = function u() {
        if (i) return !1;

        for (var t = at || dt(), n = Math.max(0, c.startTime + c.duration - t), r = 1 - (n / c.duration || 0), o = 0, s = c.tweens.length; o < s; o++) {
          c.tweens[o].run(r);
        }

        return a.notifyWith(e, [c, r, n]), r < 1 && s ? n : (s || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1);
      },
          c = a.promise({
        elem: e,
        props: T.extend({}, t),
        opts: T.extend(!0, {
          specialEasing: {},
          easing: T.easing._default
        }, n),
        originalProperties: t,
        originalOptions: n,
        startTime: at || dt(),
        duration: n.duration,
        tweens: [],
        createTween: function createTween(t, n) {
          var r = T.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
          return c.tweens.push(r), r;
        },
        stop: function stop(t) {
          var n = 0,
              r = t ? c.tweens.length : 0;
          if (i) return this;

          for (i = !0; n < r; n++) {
            c.tweens[n].run(1);
          }

          return t ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]), this;
        }
      }),
          l = c.props;

      for (!function (e, t) {
        var n, r, i, o, s;

        for (n in e) {
          if (i = t[r = G(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (s = T.cssHooks[r]) && ("expand" in s)) for (n in o = s.expand(o), delete e[r], o) {
            (n in e) || (e[n] = o[n], t[n] = i);
          } else t[r] = i;
        }
      }(l, c.opts.specialEasing); o < s; o++) {
        if (r = gt.prefilters[o].call(c, e, l, c.opts)) return y(r.stop) && (T._queueHooks(c.elem, c.opts.queue).stop = r.stop.bind(r)), r;
      }

      return T.map(l, ht, c), y(c.opts.start) && c.opts.start.call(e, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), T.fx.timer(T.extend(u, {
        elem: e,
        anim: c,
        queue: c.opts.queue
      })), c;
    }

    T.Animation = T.extend(gt, {
      tweeners: {
        "*": [function (e, t) {
          var n = this.createTween(e, t);
          return fe(n.elem, e, ie.exec(t), n), n;
        }]
      },
      tweener: function tweener(e, t) {
        y(e) ? (t = e, e = ["*"]) : e = e.match(H);

        for (var n, r = 0, i = e.length; r < i; r++) {
          n = e[r], gt.tweeners[n] = gt.tweeners[n] || [], gt.tweeners[n].unshift(t);
        }
      },
      prefilters: [function (e, t, n) {
        var r,
            i,
            o,
            s,
            a,
            u,
            c,
            l,
            f = "width" in t || "height" in t,
            d = this,
            p = {},
            h = e.style,
            g = e.nodeType && ce(e),
            v = K.get(e, "fxshow");

        for (r in n.queue || (null == (s = T._queueHooks(e, "fx")).unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function () {
          s.unqueued || a();
        }), s.unqueued++, d.always(function () {
          d.always(function () {
            s.unqueued--, T.queue(e, "fx").length || s.empty.fire();
          });
        })), t) {
          if (i = t[r], ct.test(i)) {
            if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) {
              if ("show" !== i || !v || void 0 === v[r]) continue;
              g = !0;
            }

            p[r] = v && v[r] || T.style(e, r);
          }
        }

        if ((u = !T.isEmptyObject(t)) || !T.isEmptyObject(p)) for (r in f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (c = v && v.display) && (c = K.get(e, "display")), "none" === (l = T.css(e, "display")) && (c ? l = c : (he([e], !0), c = e.style.display || c, l = T.css(e, "display"), he([e]))), ("inline" === l || "inline-block" === l && null != c) && "none" === T.css(e, "float") && (u || (d.done(function () {
          h.display = c;
        }), null == c && (l = h.display, c = "none" === l ? "" : l)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", d.always(function () {
          h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
        })), u = !1, p) {
          u || (v ? "hidden" in v && (g = v.hidden) : v = K.access(e, "fxshow", {
            display: c
          }), o && (v.hidden = !g), g && he([e], !0), d.done(function () {
            for (r in g || he([e]), K.remove(e, "fxshow"), p) {
              T.style(e, r, p[r]);
            }
          })), u = ht(g ? v[r] : 0, r, d), r in v || (v[r] = u.start, g && (u.end = u.start, u.start = 0));
        }
      }],
      prefilter: function prefilter(e, t) {
        t ? gt.prefilters.unshift(e) : gt.prefilters.push(e);
      }
    }), T.speed = function (e, t, n) {
      var r = e && "object" == _typeof(e) ? T.extend({}, e) : {
        complete: n || !n && t || y(e) && e,
        duration: e,
        easing: n && t || t && !y(t) && t
      };
      return T.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in T.fx.speeds ? r.duration = T.fx.speeds[r.duration] : r.duration = T.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
        y(r.old) && r.old.call(this), r.queue && T.dequeue(this, r.queue);
      }, r;
    }, T.fn.extend({
      fadeTo: function fadeTo(e, t, n, r) {
        return this.filter(ce).css("opacity", 0).show().end().animate({
          opacity: t
        }, e, n, r);
      },
      animate: function animate(e, t, n, r) {
        var i = T.isEmptyObject(e),
            o = T.speed(t, n, r),
            s = function s() {
          var t = gt(this, T.extend({}, e), o);
          (i || K.get(this, "finish")) && t.stop(!0);
        };

        return s.finish = s, i || !1 === o.queue ? this.each(s) : this.queue(o.queue, s);
      },
      stop: function stop(e, t, n) {
        var r = function r(e) {
          var t = e.stop;
          delete e.stop, t(n);
        };

        return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
          var t = !0,
              i = null != e && e + "queueHooks",
              o = T.timers,
              s = K.get(this);
          if (i) s[i] && s[i].stop && r(s[i]);else for (i in s) {
            s[i] && s[i].stop && lt.test(i) && r(s[i]);
          }

          for (i = o.length; i--;) {
            o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
          }

          !t && n || T.dequeue(this, e);
        });
      },
      finish: function finish(e) {
        return !1 !== e && (e = e || "fx"), this.each(function () {
          var t,
              n = K.get(this),
              r = n[e + "queue"],
              i = n[e + "queueHooks"],
              o = T.timers,
              s = r ? r.length : 0;

          for (n.finish = !0, T.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) {
            o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
          }

          for (t = 0; t < s; t++) {
            r[t] && r[t].finish && r[t].finish.call(this);
          }

          delete n.finish;
        });
      }
    }), T.each(["toggle", "show", "hide"], function (e, t) {
      var n = T.fn[t];

      T.fn[t] = function (e, r, i) {
        return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(pt(t, !0), e, r, i);
      };
    }), T.each({
      slideDown: pt("show"),
      slideUp: pt("hide"),
      slideToggle: pt("toggle"),
      fadeIn: {
        opacity: "show"
      },
      fadeOut: {
        opacity: "hide"
      },
      fadeToggle: {
        opacity: "toggle"
      }
    }, function (e, t) {
      T.fn[e] = function (e, n, r) {
        return this.animate(t, e, n, r);
      };
    }), T.timers = [], T.fx.tick = function () {
      var e,
          t = 0,
          n = T.timers;

      for (at = Date.now(); t < n.length; t++) {
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      }

      n.length || T.fx.stop(), at = void 0;
    }, T.fx.timer = function (e) {
      T.timers.push(e), T.fx.start();
    }, T.fx.interval = 13, T.fx.start = function () {
      ut || (ut = !0, ft());
    }, T.fx.stop = function () {
      ut = null;
    }, T.fx.speeds = {
      slow: 600,
      fast: 200,
      _default: 400
    }, T.fn.delay = function (e, t) {
      return e = T.fx && T.fx.speeds[e] || e, t = t || "fx", this.queue(t, function (t, r) {
        var i = n.setTimeout(t, e);

        r.stop = function () {
          n.clearTimeout(i);
        };
      });
    }, function () {
      var e = s.createElement("input"),
          t = s.createElement("select").appendChild(s.createElement("option"));
      e.type = "checkbox", m.checkOn = "" !== e.value, m.optSelected = t.selected, (e = s.createElement("input")).value = "t", e.type = "radio", m.radioValue = "t" === e.value;
    }();
    var vt,
        mt = T.expr.attrHandle;
    T.fn.extend({
      attr: function attr(e, t) {
        return U(this, T.attr, e, t, arguments.length > 1);
      },
      removeAttr: function removeAttr(e) {
        return this.each(function () {
          T.removeAttr(this, e);
        });
      }
    }), T.extend({
      attr: function attr(e, t, n) {
        var r,
            i,
            o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? T.prop(e, t, n) : (1 === o && T.isXMLDoc(e) || (i = T.attrHooks[t.toLowerCase()] || (T.expr.match.bool.test(t) ? vt : void 0)), void 0 !== n ? null === n ? void T.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = T.find.attr(e, t)) ? void 0 : r);
      },
      attrHooks: {
        type: {
          set: function set(e, t) {
            if (!m.radioValue && "radio" === t && N(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          }
        }
      },
      removeAttr: function removeAttr(e, t) {
        var n,
            r = 0,
            i = t && t.match(H);
        if (i && 1 === e.nodeType) for (; n = i[r++];) {
          e.removeAttribute(n);
        }
      }
    }), vt = {
      set: function set(e, t, n) {
        return !1 === t ? T.removeAttr(e, n) : e.setAttribute(n, n), n;
      }
    }, T.each(T.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = mt[t] || T.find.attr;

      mt[t] = function (e, t, r) {
        var i,
            o,
            s = t.toLowerCase();
        return r || (o = mt[s], mt[s] = i, i = null != n(e, t, r) ? s : null, mt[s] = o), i;
      };
    });
    var yt = /^(?:input|select|textarea|button)$/i,
        xt = /^(?:a|area)$/i;

    function bt(e) {
      return (e.match(H) || []).join(" ");
    }

    function wt(e) {
      return e.getAttribute && e.getAttribute("class") || "";
    }

    function Ct(e) {
      return Array.isArray(e) ? e : "string" == typeof e && e.match(H) || [];
    }

    T.fn.extend({
      prop: function prop(e, t) {
        return U(this, T.prop, e, t, arguments.length > 1);
      },
      removeProp: function removeProp(e) {
        return this.each(function () {
          delete this[T.propFix[e] || e];
        });
      }
    }), T.extend({
      prop: function prop(e, t, n) {
        var r,
            i,
            o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o) return 1 === o && T.isXMLDoc(e) || (t = T.propFix[t] || t, i = T.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
      },
      propHooks: {
        tabIndex: {
          get: function get(e) {
            var t = T.find.attr(e, "tabindex");
            return t ? parseInt(t, 10) : yt.test(e.nodeName) || xt.test(e.nodeName) && e.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), m.optSelected || (T.propHooks.selected = {
      get: function get(e) {
        var t = e.parentNode;
        return t && t.parentNode && t.parentNode.selectedIndex, null;
      },
      set: function set(e) {
        var t = e.parentNode;
        t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
      }
    }), T.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
      T.propFix[this.toLowerCase()] = this;
    }), T.fn.extend({
      addClass: function addClass(e) {
        var t,
            n,
            r,
            i,
            o,
            s,
            a,
            u = 0;
        if (y(e)) return this.each(function (t) {
          T(this).addClass(e.call(this, t, wt(this)));
        });
        if ((t = Ct(e)).length) for (; n = this[u++];) {
          if (i = wt(n), r = 1 === n.nodeType && " " + bt(i) + " ") {
            for (s = 0; o = t[s++];) {
              r.indexOf(" " + o + " ") < 0 && (r += o + " ");
            }

            i !== (a = bt(r)) && n.setAttribute("class", a);
          }
        }
        return this;
      },
      removeClass: function removeClass(e) {
        var t,
            n,
            r,
            i,
            o,
            s,
            a,
            u = 0;
        if (y(e)) return this.each(function (t) {
          T(this).removeClass(e.call(this, t, wt(this)));
        });
        if (!arguments.length) return this.attr("class", "");
        if ((t = Ct(e)).length) for (; n = this[u++];) {
          if (i = wt(n), r = 1 === n.nodeType && " " + bt(i) + " ") {
            for (s = 0; o = t[s++];) {
              for (; r.indexOf(" " + o + " ") > -1;) {
                r = r.replace(" " + o + " ", " ");
              }
            }

            i !== (a = bt(r)) && n.setAttribute("class", a);
          }
        }
        return this;
      },
      toggleClass: function toggleClass(e, t) {
        var n = _typeof(e),
            r = "string" === n || Array.isArray(e);

        return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : y(e) ? this.each(function (n) {
          T(this).toggleClass(e.call(this, n, wt(this), t), t);
        }) : this.each(function () {
          var t, i, o, s;
          if (r) for (i = 0, o = T(this), s = Ct(e); t = s[i++];) {
            o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
          } else void 0 !== e && "boolean" !== n || ((t = wt(this)) && K.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : K.get(this, "__className__") || ""));
        });
      },
      hasClass: function hasClass(e) {
        var t,
            n,
            r = 0;

        for (t = " " + e + " "; n = this[r++];) {
          if (1 === n.nodeType && (" " + bt(wt(n)) + " ").indexOf(t) > -1) return !0;
        }

        return !1;
      }
    });
    var Tt = /\r/g;
    T.fn.extend({
      val: function val(e) {
        var t,
            n,
            r,
            i = this[0];
        return arguments.length ? (r = y(e), this.each(function (n) {
          var i;
          1 === this.nodeType && (null == (i = r ? e.call(this, n, T(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = T.map(i, function (e) {
            return null == e ? "" : e + "";
          })), (t = T.valHooks[this.type] || T.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
        })) : i ? (t = T.valHooks[i.type] || T.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(Tt, "") : null == n ? "" : n : void 0;
      }
    }), T.extend({
      valHooks: {
        option: {
          get: function get(e) {
            var t = T.find.attr(e, "value");
            return null != t ? t : bt(T.text(e));
          }
        },
        select: {
          get: function get(e) {
            var t,
                n,
                r,
                i = e.options,
                o = e.selectedIndex,
                s = "select-one" === e.type,
                a = s ? null : [],
                u = s ? o + 1 : i.length;

            for (r = o < 0 ? u : s ? o : 0; r < u; r++) {
              if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))) {
                if (t = T(n).val(), s) return t;
                a.push(t);
              }
            }

            return a;
          },
          set: function set(e, t) {
            for (var n, r, i = e.options, o = T.makeArray(t), s = i.length; s--;) {
              ((r = i[s]).selected = T.inArray(T.valHooks.option.get(r), o) > -1) && (n = !0);
            }

            return n || (e.selectedIndex = -1), o;
          }
        }
      }
    }), T.each(["radio", "checkbox"], function () {
      T.valHooks[this] = {
        set: function set(e, t) {
          if (Array.isArray(t)) return e.checked = T.inArray(T(e).val(), t) > -1;
        }
      }, m.checkOn || (T.valHooks[this].get = function (e) {
        return null === e.getAttribute("value") ? "on" : e.value;
      });
    }), m.focusin = "onfocusin" in n;

    var kt = /^(?:focusinfocus|focusoutblur)$/,
        St = function St(e) {
      e.stopPropagation();
    };

    T.extend(T.event, {
      trigger: function trigger(e, t, r, i) {
        var o,
            a,
            u,
            c,
            l,
            f,
            d,
            p,
            g = [r || s],
            v = h.call(e, "type") ? e.type : e,
            m = h.call(e, "namespace") ? e.namespace.split(".") : [];

        if (a = p = u = r = r || s, 3 !== r.nodeType && 8 !== r.nodeType && !kt.test(v + T.event.triggered) && (v.indexOf(".") > -1 && (m = v.split("."), v = m.shift(), m.sort()), l = v.indexOf(":") < 0 && "on" + v, (e = e[T.expando] ? e : new T.Event(v, "object" == _typeof(e) && e)).isTrigger = i ? 2 : 3, e.namespace = m.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = r), t = null == t ? [e] : T.makeArray(t, [e]), d = T.event.special[v] || {}, i || !d.trigger || !1 !== d.trigger.apply(r, t))) {
          if (!i && !d.noBubble && !x(r)) {
            for (c = d.delegateType || v, kt.test(c + v) || (a = a.parentNode); a; a = a.parentNode) {
              g.push(a), u = a;
            }

            u === (r.ownerDocument || s) && g.push(u.defaultView || u.parentWindow || n);
          }

          for (o = 0; (a = g[o++]) && !e.isPropagationStopped();) {
            p = a, e.type = o > 1 ? c : d.bindType || v, (f = (K.get(a, "events") || {})[e.type] && K.get(a, "handle")) && f.apply(a, t), (f = l && a[l]) && f.apply && Y(a) && (e.result = f.apply(a, t), !1 === e.result && e.preventDefault());
          }

          return e.type = v, i || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(g.pop(), t) || !Y(r) || l && y(r[v]) && !x(r) && ((u = r[l]) && (r[l] = null), T.event.triggered = v, e.isPropagationStopped() && p.addEventListener(v, St), r[v](), e.isPropagationStopped() && p.removeEventListener(v, St), T.event.triggered = void 0, u && (r[l] = u)), e.result;
        }
      },
      simulate: function simulate(e, t, n) {
        var r = T.extend(new T.Event(), n, {
          type: e,
          isSimulated: !0
        });
        T.event.trigger(r, null, t);
      }
    }), T.fn.extend({
      trigger: function trigger(e, t) {
        return this.each(function () {
          T.event.trigger(e, t, this);
        });
      },
      triggerHandler: function triggerHandler(e, t) {
        var n = this[0];
        if (n) return T.event.trigger(e, t, n, !0);
      }
    }), m.focusin || T.each({
      focus: "focusin",
      blur: "focusout"
    }, function (e, t) {
      var n = function n(e) {
        T.event.simulate(t, e.target, T.event.fix(e));
      };

      T.event.special[t] = {
        setup: function setup() {
          var r = this.ownerDocument || this,
              i = K.access(r, t);
          i || r.addEventListener(e, n, !0), K.access(r, t, (i || 0) + 1);
        },
        teardown: function teardown() {
          var r = this.ownerDocument || this,
              i = K.access(r, t) - 1;
          i ? K.access(r, t, i) : (r.removeEventListener(e, n, !0), K.remove(r, t));
        }
      };
    });
    var Et = n.location,
        jt = Date.now(),
        Dt = /\?/;

    T.parseXML = function (e) {
      var t;
      if (!e || "string" != typeof e) return null;

      try {
        t = new n.DOMParser().parseFromString(e, "text/xml");
      } catch (e) {
        t = void 0;
      }

      return t && !t.getElementsByTagName("parsererror").length || T.error("Invalid XML: " + e), t;
    };

    var At = /\[\]$/,
        Nt = /\r?\n/g,
        Ot = /^(?:submit|button|image|reset|file)$/i,
        qt = /^(?:input|select|textarea|keygen)/i;

    function Lt(e, t, n, r) {
      var i;
      if (Array.isArray(t)) T.each(t, function (t, i) {
        n || At.test(e) ? r(e, i) : Lt(e + "[" + ("object" == _typeof(i) && null != i ? t : "") + "]", i, n, r);
      });else if (n || "object" !== C(t)) r(e, t);else for (i in t) {
        Lt(e + "[" + i + "]", t[i], n, r);
      }
    }

    T.param = function (e, t) {
      var n,
          r = [],
          i = function i(e, t) {
        var n = y(t) ? t() : t;
        r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
      };

      if (null == e) return "";
      if (Array.isArray(e) || e.jquery && !T.isPlainObject(e)) T.each(e, function () {
        i(this.name, this.value);
      });else for (n in e) {
        Lt(n, e[n], t, i);
      }
      return r.join("&");
    }, T.fn.extend({
      serialize: function serialize() {
        return T.param(this.serializeArray());
      },
      serializeArray: function serializeArray() {
        return this.map(function () {
          var e = T.prop(this, "elements");
          return e ? T.makeArray(e) : this;
        }).filter(function () {
          var e = this.type;
          return this.name && !T(this).is(":disabled") && qt.test(this.nodeName) && !Ot.test(e) && (this.checked || !ge.test(e));
        }).map(function (e, t) {
          var n = T(this).val();
          return null == n ? null : Array.isArray(n) ? T.map(n, function (e) {
            return {
              name: t.name,
              value: e.replace(Nt, "\r\n")
            };
          }) : {
            name: t.name,
            value: n.replace(Nt, "\r\n")
          };
        }).get();
      }
    });
    var _t = /%20/g,
        Mt = /#.*$/,
        Pt = /([?&])_=[^&]*/,
        It = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ht = /^(?:GET|HEAD)$/,
        $t = /^\/\//,
        Rt = {},
        Bt = {},
        Wt = "*/".concat("*"),
        Ft = s.createElement("a");

    function zt(e) {
      return function (t, n) {
        "string" != typeof t && (n = t, t = "*");
        var r,
            i = 0,
            o = t.toLowerCase().match(H) || [];
        if (y(n)) for (; r = o[i++];) {
          "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
        }
      };
    }

    function Ut(e, t, n, r) {
      var i = {},
          o = e === Bt;

      function s(a) {
        var u;
        return i[a] = !0, T.each(e[a] || [], function (e, a) {
          var c = a(t, n, r);
          return "string" != typeof c || o || i[c] ? o ? !(u = c) : void 0 : (t.dataTypes.unshift(c), s(c), !1);
        }), u;
      }

      return s(t.dataTypes[0]) || !i["*"] && s("*");
    }

    function Xt(e, t) {
      var n,
          r,
          i = T.ajaxSettings.flatOptions || {};

      for (n in t) {
        void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
      }

      return r && T.extend(!0, e, r), e;
    }

    Ft.href = Et.href, T.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Et.href,
        type: "GET",
        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Wt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": T.parseXML
        },
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      ajaxSetup: function ajaxSetup(e, t) {
        return t ? Xt(Xt(e, T.ajaxSettings), t) : Xt(T.ajaxSettings, e);
      },
      ajaxPrefilter: zt(Rt),
      ajaxTransport: zt(Bt),
      ajax: function ajax(e, t) {
        "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
        var r,
            i,
            o,
            a,
            u,
            c,
            l,
            f,
            d,
            p,
            h = T.ajaxSetup({}, t),
            g = h.context || h,
            v = h.context && (g.nodeType || g.jquery) ? T(g) : T.event,
            m = T.Deferred(),
            y = T.Callbacks("once memory"),
            x = h.statusCode || {},
            b = {},
            w = {},
            C = "canceled",
            k = {
          readyState: 0,
          getResponseHeader: function getResponseHeader(e) {
            var t;

            if (l) {
              if (!a) for (a = {}; t = It.exec(o);) {
                a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
              }
              t = a[e.toLowerCase() + " "];
            }

            return null == t ? null : t.join(", ");
          },
          getAllResponseHeaders: function getAllResponseHeaders() {
            return l ? o : null;
          },
          setRequestHeader: function setRequestHeader(e, t) {
            return null == l && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, b[e] = t), this;
          },
          overrideMimeType: function overrideMimeType(e) {
            return null == l && (h.mimeType = e), this;
          },
          statusCode: function statusCode(e) {
            var t;
            if (e) if (l) k.always(e[k.status]);else for (t in e) {
              x[t] = [x[t], e[t]];
            }
            return this;
          },
          abort: function abort(e) {
            var t = e || C;
            return r && r.abort(t), S(0, t), this;
          }
        };

        if (m.promise(k), h.url = ((e || h.url || Et.href) + "").replace($t, Et.protocol + "//"), h.type = t.method || t.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(H) || [""], null == h.crossDomain) {
          c = s.createElement("a");

          try {
            c.href = h.url, c.href = c.href, h.crossDomain = Ft.protocol + "//" + Ft.host != c.protocol + "//" + c.host;
          } catch (e) {
            h.crossDomain = !0;
          }
        }

        if (h.data && h.processData && "string" != typeof h.data && (h.data = T.param(h.data, h.traditional)), Ut(Rt, h, t, k), l) return k;

        for (d in (f = T.event && h.global) && 0 == T.active++ && T.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !Ht.test(h.type), i = h.url.replace(Mt, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(_t, "+")) : (p = h.url.slice(i.length), h.data && (h.processData || "string" == typeof h.data) && (i += (Dt.test(i) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (i = i.replace(Pt, "$1"), p = (Dt.test(i) ? "&" : "?") + "_=" + jt++ + p), h.url = i + p), h.ifModified && (T.lastModified[i] && k.setRequestHeader("If-Modified-Since", T.lastModified[i]), T.etag[i] && k.setRequestHeader("If-None-Match", T.etag[i])), (h.data && h.hasContent && !1 !== h.contentType || t.contentType) && k.setRequestHeader("Content-Type", h.contentType), k.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Wt + "; q=0.01" : "") : h.accepts["*"]), h.headers) {
          k.setRequestHeader(d, h.headers[d]);
        }

        if (h.beforeSend && (!1 === h.beforeSend.call(g, k, h) || l)) return k.abort();

        if (C = "abort", y.add(h.complete), k.done(h.success), k.fail(h.error), r = Ut(Bt, h, t, k)) {
          if (k.readyState = 1, f && v.trigger("ajaxSend", [k, h]), l) return k;
          h.async && h.timeout > 0 && (u = n.setTimeout(function () {
            k.abort("timeout");
          }, h.timeout));

          try {
            l = !1, r.send(b, S);
          } catch (e) {
            if (l) throw e;
            S(-1, e);
          }
        } else S(-1, "No Transport");

        function S(e, t, s, a) {
          var c,
              d,
              p,
              b,
              w,
              C = t;
          l || (l = !0, u && n.clearTimeout(u), r = void 0, o = a || "", k.readyState = e > 0 ? 4 : 0, c = e >= 200 && e < 300 || 304 === e, s && (b = function (e, t, n) {
            for (var r, i, o, s, a = e.contents, u = e.dataTypes; "*" === u[0];) {
              u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
            }

            if (r) for (i in a) {
              if (a[i] && a[i].test(r)) {
                u.unshift(i);
                break;
              }
            }
            if (u[0] in n) o = u[0];else {
              for (i in n) {
                if (!u[0] || e.converters[i + " " + u[0]]) {
                  o = i;
                  break;
                }

                s || (s = i);
              }

              o = o || s;
            }
            if (o) return o !== u[0] && u.unshift(o), n[o];
          }(h, k, s)), b = function (e, t, n, r) {
            var i,
                o,
                s,
                a,
                u,
                c = {},
                l = e.dataTypes.slice();
            if (l[1]) for (s in e.converters) {
              c[s.toLowerCase()] = e.converters[s];
            }

            for (o = l.shift(); o;) {
              if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = l.shift()) if ("*" === o) o = u;else if ("*" !== u && u !== o) {
                if (!(s = c[u + " " + o] || c["* " + o])) for (i in c) {
                  if ((a = i.split(" "))[1] === o && (s = c[u + " " + a[0]] || c["* " + a[0]])) {
                    !0 === s ? s = c[i] : !0 !== c[i] && (o = a[0], l.unshift(a[1]));
                    break;
                  }
                }
                if (!0 !== s) if (s && e.throws) t = s(t);else try {
                  t = s(t);
                } catch (e) {
                  return {
                    state: "parsererror",
                    error: s ? e : "No conversion from " + u + " to " + o
                  };
                }
              }
            }

            return {
              state: "success",
              data: t
            };
          }(h, b, k, c), c ? (h.ifModified && ((w = k.getResponseHeader("Last-Modified")) && (T.lastModified[i] = w), (w = k.getResponseHeader("etag")) && (T.etag[i] = w)), 204 === e || "HEAD" === h.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = b.state, d = b.data, c = !(p = b.error))) : (p = C, !e && C || (C = "error", e < 0 && (e = 0))), k.status = e, k.statusText = (t || C) + "", c ? m.resolveWith(g, [d, C, k]) : m.rejectWith(g, [k, C, p]), k.statusCode(x), x = void 0, f && v.trigger(c ? "ajaxSuccess" : "ajaxError", [k, h, c ? d : p]), y.fireWith(g, [k, C]), f && (v.trigger("ajaxComplete", [k, h]), --T.active || T.event.trigger("ajaxStop")));
        }

        return k;
      },
      getJSON: function getJSON(e, t, n) {
        return T.get(e, t, n, "json");
      },
      getScript: function getScript(e, t) {
        return T.get(e, void 0, t, "script");
      }
    }), T.each(["get", "post"], function (e, t) {
      T[t] = function (e, n, r, i) {
        return y(n) && (i = i || r, r = n, n = void 0), T.ajax(T.extend({
          url: e,
          type: t,
          dataType: i,
          data: n,
          success: r
        }, T.isPlainObject(e) && e));
      };
    }), T._evalUrl = function (e, t) {
      return T.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: {
          "text script": function textScript() {}
        },
        dataFilter: function dataFilter(e) {
          T.globalEval(e, t);
        }
      });
    }, T.fn.extend({
      wrapAll: function wrapAll(e) {
        var t;
        return this[0] && (y(e) && (e = e.call(this[0])), t = T(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
          for (var e = this; e.firstElementChild;) {
            e = e.firstElementChild;
          }

          return e;
        }).append(this)), this;
      },
      wrapInner: function wrapInner(e) {
        return y(e) ? this.each(function (t) {
          T(this).wrapInner(e.call(this, t));
        }) : this.each(function () {
          var t = T(this),
              n = t.contents();
          n.length ? n.wrapAll(e) : t.append(e);
        });
      },
      wrap: function wrap(e) {
        var t = y(e);
        return this.each(function (n) {
          T(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function unwrap(e) {
        return this.parent(e).not("body").each(function () {
          T(this).replaceWith(this.childNodes);
        }), this;
      }
    }), T.expr.pseudos.hidden = function (e) {
      return !T.expr.pseudos.visible(e);
    }, T.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }, T.ajaxSettings.xhr = function () {
      try {
        return new n.XMLHttpRequest();
      } catch (e) {}
    };
    var Qt = {
      0: 200,
      1223: 204
    },
        Vt = T.ajaxSettings.xhr();
    m.cors = !!Vt && "withCredentials" in Vt, m.ajax = Vt = !!Vt, T.ajaxTransport(function (e) {
      var _t3, r;

      if (m.cors || Vt && !e.crossDomain) return {
        send: function send(i, o) {
          var s,
              a = e.xhr();
          if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (s in e.xhrFields) {
            a[s] = e.xhrFields[s];
          }

          for (s in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i) {
            a.setRequestHeader(s, i[s]);
          }

          _t3 = function t(e) {
            return function () {
              _t3 && (_t3 = r = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null, "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(Qt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                binary: a.response
              } : {
                text: a.responseText
              }, a.getAllResponseHeaders()));
            };
          }, a.onload = _t3(), r = a.onerror = a.ontimeout = _t3("error"), void 0 !== a.onabort ? a.onabort = r : a.onreadystatechange = function () {
            4 === a.readyState && n.setTimeout(function () {
              _t3 && r();
            });
          }, _t3 = _t3("abort");

          try {
            a.send(e.hasContent && e.data || null);
          } catch (e) {
            if (_t3) throw e;
          }
        },
        abort: function abort() {
          _t3 && _t3();
        }
      };
    }), T.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }), T.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function textScript(e) {
          return T.globalEval(e), e;
        }
      }
    }), T.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }), T.ajaxTransport("script", function (e) {
      var t, _n;

      if (e.crossDomain || e.scriptAttrs) return {
        send: function send(r, i) {
          t = T("<script>").attr(e.scriptAttrs || {}).prop({
            charset: e.scriptCharset,
            src: e.url
          }).on("load error", _n = function n(e) {
            t.remove(), _n = null, e && i("error" === e.type ? 404 : 200, e.type);
          }), s.head.appendChild(t[0]);
        },
        abort: function abort() {
          _n && _n();
        }
      };
    });
    var Gt,
        Yt = [],
        Jt = /(=)\?(?=&|$)|\?\?/;
    T.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function jsonpCallback() {
        var e = Yt.pop() || T.expando + "_" + jt++;
        return this[e] = !0, e;
      }
    }), T.ajaxPrefilter("json jsonp", function (e, t, r) {
      var i,
          o,
          s,
          a = !1 !== e.jsonp && (Jt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Jt.test(e.data) && "data");
      if (a || "jsonp" === e.dataTypes[0]) return i = e.jsonpCallback = y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Jt, "$1" + i) : !1 !== e.jsonp && (e.url += (Dt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function () {
        return s || T.error(i + " was not called"), s[0];
      }, e.dataTypes[0] = "json", o = n[i], n[i] = function () {
        s = arguments;
      }, r.always(function () {
        void 0 === o ? T(n).removeProp(i) : n[i] = o, e[i] && (e.jsonpCallback = t.jsonpCallback, Yt.push(i)), s && y(o) && o(s[0]), s = o = void 0;
      }), "script";
    }), m.createHTMLDocument = ((Gt = s.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Gt.childNodes.length), T.parseHTML = function (e, t, n) {
      return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (m.createHTMLDocument ? ((r = (t = s.implementation.createHTMLDocument("")).createElement("base")).href = s.location.href, t.head.appendChild(r)) : t = s), o = !n && [], (i = O.exec(e)) ? [t.createElement(i[1])] : (i = ke([e], t, o), o && o.length && T(o).remove(), T.merge([], i.childNodes)));
      var r, i, o;
    }, T.fn.load = function (e, t, n) {
      var r,
          i,
          o,
          s = this,
          a = e.indexOf(" ");
      return a > -1 && (r = bt(e.slice(a)), e = e.slice(0, a)), y(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (i = "POST"), s.length > 0 && T.ajax({
        url: e,
        type: i || "GET",
        dataType: "html",
        data: t
      }).done(function (e) {
        o = arguments, s.html(r ? T("<div>").append(T.parseHTML(e)).find(r) : e);
      }).always(n && function (e, t) {
        s.each(function () {
          n.apply(this, o || [e.responseText, t, e]);
        });
      }), this;
    }, T.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
      T.fn[t] = function (e) {
        return this.on(t, e);
      };
    }), T.expr.pseudos.animated = function (e) {
      return T.grep(T.timers, function (t) {
        return e === t.elem;
      }).length;
    }, T.offset = {
      setOffset: function setOffset(e, t, n) {
        var r,
            i,
            o,
            s,
            a,
            u,
            c = T.css(e, "position"),
            l = T(e),
            f = {};
        "static" === c && (e.style.position = "relative"), a = l.offset(), o = T.css(e, "top"), u = T.css(e, "left"), ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1 ? (s = (r = l.position()).top, i = r.left) : (s = parseFloat(o) || 0, i = parseFloat(u) || 0), y(t) && (t = t.call(e, n, T.extend({}, a))), null != t.top && (f.top = t.top - a.top + s), null != t.left && (f.left = t.left - a.left + i), "using" in t ? t.using.call(e, f) : l.css(f);
      }
    }, T.fn.extend({
      offset: function offset(e) {
        if (arguments.length) return void 0 === e ? this : this.each(function (t) {
          T.offset.setOffset(this, e, t);
        });
        var t,
            n,
            r = this[0];
        return r ? r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
          top: t.top + n.pageYOffset,
          left: t.left + n.pageXOffset
        }) : {
          top: 0,
          left: 0
        } : void 0;
      },
      position: function position() {
        if (this[0]) {
          var e,
              t,
              n,
              r = this[0],
              i = {
            top: 0,
            left: 0
          };
          if ("fixed" === T.css(r, "position")) t = r.getBoundingClientRect();else {
            for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === T.css(e, "position");) {
              e = e.parentNode;
            }

            e && e !== r && 1 === e.nodeType && ((i = T(e).offset()).top += T.css(e, "borderTopWidth", !0), i.left += T.css(e, "borderLeftWidth", !0));
          }
          return {
            top: t.top - i.top - T.css(r, "marginTop", !0),
            left: t.left - i.left - T.css(r, "marginLeft", !0)
          };
        }
      },
      offsetParent: function offsetParent() {
        return this.map(function () {
          for (var e = this.offsetParent; e && "static" === T.css(e, "position");) {
            e = e.offsetParent;
          }

          return e || se;
        });
      }
    }), T.each({
      scrollLeft: "pageXOffset",
      scrollTop: "pageYOffset"
    }, function (e, t) {
      var n = "pageYOffset" === t;

      T.fn[e] = function (r) {
        return U(this, function (e, r, i) {
          var o;
          if (x(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];
          o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
        }, e, r, arguments.length);
      };
    }), T.each(["top", "left"], function (e, t) {
      T.cssHooks[t] = Ve(m.pixelPosition, function (e, n) {
        if (n) return n = Qe(e, t), ze.test(n) ? T(e).position()[t] + "px" : n;
      });
    }), T.each({
      Height: "height",
      Width: "width"
    }, function (e, t) {
      T.each({
        padding: "inner" + e,
        content: t,
        "": "outer" + e
      }, function (n, r) {
        T.fn[r] = function (i, o) {
          var s = arguments.length && (n || "boolean" != typeof i),
              a = n || (!0 === i || !0 === o ? "margin" : "border");
          return U(this, function (t, n, i) {
            var o;
            return x(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? T.css(t, n, a) : T.style(t, n, i, a);
          }, t, s ? i : void 0, s);
        };
      });
    }), T.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
      T.fn[t] = function (e, n) {
        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
      };
    }), T.fn.extend({
      hover: function hover(e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      }
    }), T.fn.extend({
      bind: function bind(e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function unbind(e, t) {
        return this.off(e, null, t);
      },
      delegate: function delegate(e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function undelegate(e, t, n) {
        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
      }
    }), T.proxy = function (e, t) {
      var n, r, i;
      if ("string" == typeof t && (n = e[t], t = e, e = n), y(e)) return r = u.call(arguments, 2), (i = function i() {
        return e.apply(t || this, r.concat(u.call(arguments)));
      }).guid = e.guid = e.guid || T.guid++, i;
    }, T.holdReady = function (e) {
      e ? T.readyWait++ : T.ready(!0);
    }, T.isArray = Array.isArray, T.parseJSON = JSON.parse, T.nodeName = N, T.isFunction = y, T.isWindow = x, T.camelCase = G, T.type = C, T.now = Date.now, T.isNumeric = function (e) {
      var t = T.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }, void 0 === (r = function () {
      return T;
    }.apply(t, [])) || (e.exports = r);
    var Kt = n.jQuery,
        Zt = n.$;
    return T.noConflict = function (e) {
      return n.$ === T && (n.$ = Zt), e && n.jQuery === T && (n.jQuery = Kt), T;
    }, i || (n.jQuery = n.$ = T), T;
  });
}, function (e, t, n) {
  "use strict";

  (function (e) {
    n.d(t, "a", function () {
      return i;
    }), n.d(t, "d", function () {
      return o;
    }), n.d(t, "g", function () {
      return s;
    }), n.d(t, "c", function () {
      return a;
    }), n.d(t, "b", function () {
      return u;
    }), n.d(t, "f", function () {
      return c;
    }), n.d(t, "h", function () {
      return l;
    }), n.d(t, "e", function () {
      return f;
    });
    var r = n(0);

    function i() {
      var t = ".p-center-mode-slider",
          n = "".concat(t, "__slides"),
          r = "".concat(t, "__slide");
      e(n).slick({
        arrows: !1,
        dots: !1,
        centerMode: !0,
        slidesToShow: 1,
        centerPadding: "23.57vw",
        responsive: [{
          breakpoint: 768,
          settings: {
            infinite: !1,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: !0,
            centerMode: !1,
            centerPadding: 0
          }
        }]
      }), e(r).on("click", function () {
        var t = e(this).attr("data-slick-index");
        e(n).slick("slickGoTo", t);
      });
    }

    function o(t) {
      var n = e.extend({}, {
        dots: !0
      }, t);
      e(".p-mv__slides").on("init", function (t, n) {
        setTimeout(function () {
          e(n.$slides[0]).addClass("is-active");
        }, 500);
      }).on("beforeChange", function (t, n, r, i) {
        e(".p-mv__slide").removeClass("is-active");
      }).on("afterChange", function (t, n, r) {
        e(n.$slides[r]).addClass("is-active");
      }).slick(n);
    }

    function s() {
      var t = ".p-stories",
          n = "".concat(t, "__item"),
          i = "".concat(t, "__images"),
          o = "".concat(t, "__img"),
          s = "".concat(t, "__texts"),
          a = "".concat(t, "__text"),
          u = e(t).find(".c-heading4a"),
          c = function c() {
        e(n).each(function () {
          e(this).find(o).clone(!1, !1).appendTo(i);
        }), e(n).eq(0).find(u).trigger("click");
      },
          l = function l() {
        e("[class*=c-read-more]").on("click", function () {
          e(this).hide(), e(this).prev(s).addClass("is-open").find(a).css("display", "block");
        });
      };

      c(), e(u).on("click", function () {
        var t = e(this).parents(n),
            a = t.find(s),
            c = t.index();
        !t.hasClass("is-open") && r.b("PC") && (e(n).removeClass("is-open"), e(u).removeClass("is-active"), e(s).slideUp(400, function () {
          e(this).attr("style", "");
        }), t.addClass("is-open"), a.slideDown(400, function () {
          t.find(u).addClass("is-active");
        }), e(i).find(o).hide(), e(i).find(o).eq(c).fadeIn(400));
      }), l(), e(window).on("load", function () {
        c();
      }), e(window).on("isDeviceSwitched", function () {
        e(s).removeClass("is-open").attr("style", ""), e(a).attr("style", ""), e(l).attr("style", ""), e(n).eq(0).find(u).trigger("click");
      });
    }

    function a() {
      var t = ".p-local-navi",
          n = "".concat(t, "__inner"),
          r = "".concat(t, "__label"),
          i = "".concat(t, "__items"),
          o = "".concat(t, "__item"),
          s = !1,
          a = function a() {
        var i = "Overview";
        e(o).each(function () {
          e(this).hasClass("is-current") && (i = e(this).find("a").text());
        }), e(r).find("span").text(i), e(t).css({
          "min-height": e(n).outerHeight()
        });
      },
          u = function u() {
        e(t).css({
          "z-index": ""
        }), e(i).stop().slideUp(400, function () {
          e(this).attr("style", "").removeClass("is-open"), s = !1, e(window).trigger("bodyFixedOff");
        }), e(".l-page__content").removeClass("is-screen-on");
      };

      a(), e(r).on("click", function (n) {
        s ? (u(), e(this).removeClass("is-active")) : (s = !0, e(t).css({
          "z-index": 99999
        }), e(i).stop().slideDown(400, function () {
          e(this).addClass("is-open");
        }), e(".l-page__content").addClass("is-screen-on"), e(window).trigger("bodyFixedOn"), e(this).addClass("is-active")), n.stopPropagation();
      }), e(".l-page__content").on("click", function (e) {
        s && u(), e.stopPropagation();
      }), e(window).on("isDeviceSwitched", function () {
        a(), s && u();
      }), e(window).on("load resize scroll", function () {
        e(window).scrollTop() > e(t).offset().top ? e(n).addClass("is-fixed") : e(n).removeClass("is-fixed");
      });
    }

    function u() {
      var t = ".p-color-variation",
          n = "".concat(t, "__sliders"),
          r = "".concat(t, "__slides"),
          i = "".concat(t, "__thumbnail"),
          o = !1;
      e(n).on("beforeChange", function (e, t, n, r) {
        o = !0;
      }).on("afterChange", function (e, t, n) {
        o = !1;
      }).slick({
        dots: !1,
        arrows: !1,
        swipe: !1,
        infinite: !1
      }), e(r).slick({
        dots: !0,
        arrows: !0
      }), e(i).on("click", function () {
        if (o) return;
        var t = e(this).index();
        e(i).removeClass("is-active"), e(this).addClass("is-active"), e(n).slick("slickGoTo", t);
      });
    }

    function c() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .15;
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .4;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
      var o,
          s,
          a = ".p-staff-roll-mv",
          u = "".concat(a, "__screen"),
          c = "".concat(a, "__header"),
          l = "".concat(a, "__content");
      e(window).on("load resize scroll", function () {
        o = e(l).outerHeight(), s = r.a.var.scrollTop / e(window).height() < 1 ? r.a.var.scrollTop / e(window).height() : 1, function () {
          var r = i,
              o = t,
              a = n;
          e(c).length > 0 && e(c).css({
            "margin-top": "-".concat(r * s, "px"),
            opacity: "".concat(1 - 1.5 * s)
          }), e(u).css({
            opacity: o + (a - o) * s
          });
        }(), r.a.var.scrollBtm > e(l).offset().top + o ? e(a).addClass("is-absoluted") : e(a).removeClass("is-absoluted");
      });
    }

    function l() {
      var t = ".p-watch-movie",
          n = "".concat(t, "__mov"),
          r = "".concat(t, "__close");
      e(t).each(function () {
        var t = e(this);
        t.find(".c-play-btn").on("click", function () {
          t.find(n).fadeIn(600, "easeOutCubic", function () {
            e(this).find("video").get(0).play();
          });
        });
      }), e(r).on("click", function () {
        e(this).siblings("video").get(0).pause(), e(this).parents(t).find(n).fadeOut(600, "easeOutCubic");
      });
    }

    function f() {
      var t = ".p-smooth-selector",
          n = "".concat(t, "__inner"),
          i = "".concat(t, "__items"),
          o = "".concat(t, "__item"),
          s = "".concat("".concat(t, "__border"), " >span"),
          a = [],
          u = 0,
          c = function c(_c) {
        var f = e(t).eq(_c).find(o + ".is-active");
        e(t).eq(_c).attr("data-index", _c), a[_c] = {
          width: f.width(),
          left: f.position().left + parseInt(f.css("margin-left"))
        },u = 0,
        e(t).eq(_c).find(i).attr("style", "");
//           r.b("PC") ? e(t).eq(_c).find(i).attr("style", "") : (e(t).eq(_c).find(o).each(function () {
//           u += e(this).outerWidth(!0);
//         }), e(t).eq(_c).find(i).css({
//           "min-width": u + .05 * e(window).width(),
//           display: "flex"
//         }).queue(function () {
//           a[_c] = {
//             width: f.width(),
//             left: f.position().left + parseInt(f.css("margin-left"))
//           }, l(e(t).eq(_c).find(s), a[_c].width, a[_c].left), console.log("moveLine: " + a[_c].left), e(this).dequeue();
//         }).queue(function () {
//           e(n).animate({
//             scrollLeft: a[_c].left
//           }, 600, "easeOutCubic"), e(this).dequeue();
//         }));
      },
          l = function l(e, t, n) {
        e.css({
          width: t,
          left: n
        });
      };

      e(t).each(function (t) {
        c(t);
        var n = e(this).find(s),
            r = a[t].width,
            i = a[t].left;
        l(n, r, i);
      }), e(window).on("load isDeviceSwitched", function () {
        e(t).each(function (e) {
          c(e);
        });
      }), e(o).on("mouseenter", function () {
        var n = e(this).parents(t).find(s),
            r = e(this).width(),
            i = e(this).position().left + parseInt(e(this).css("margin-left"));
        l(n, r, i);
      }), e(o).on("click", function () {
        var n = e(this).parents(t),
            r = parseInt(n.attr("data-index")),
            i = n.find(s),
            o = e(this).width(),
            u = e(this).position().left + parseInt(e(this).css("margin-left"));
        l(i, o, u), a[r].width = o, a[r].left = u;
      }), e(i).on("mouseleave", function () {
        var n = e(this).parents(t),
            r = parseInt(n.attr("data-index")),
            i = n.find(s),
            o = a[r].width,
            u = a[r].left;
        l(i, o, u);
      });
    }
  }).call(this, n(2));
}, function (e, t, n) {
  (function (e) {
    e.easing.jswing = e.easing.swing, e.extend(e.easing, {
      def: "easeOutQuad",
      swing: function swing(t, n, r, i, o) {
        return e.easing[e.easing.def](t, n, r, i, o);
      },
      easeInQuad: function easeInQuad(e, t, n, r, i) {
        return r * (t /= i) * t + n;
      },
      easeOutQuad: function easeOutQuad(e, t, n, r, i) {
        return -r * (t /= i) * (t - 2) + n;
      },
      easeInOutQuad: function easeInOutQuad(e, t, n, r, i) {
        return (t /= i / 2) < 1 ? r / 2 * t * t + n : -r / 2 * (--t * (t - 2) - 1) + n;
      },
      easeInCubic: function easeInCubic(e, t, n, r, i) {
        return r * (t /= i) * t * t + n;
      },
      easeOutCubic: function easeOutCubic(e, t, n, r, i) {
        return r * ((t = t / i - 1) * t * t + 1) + n;
      },
      easeInOutCubic: function easeInOutCubic(e, t, n, r, i) {
        return (t /= i / 2) < 1 ? r / 2 * t * t * t + n : r / 2 * ((t -= 2) * t * t + 2) + n;
      },
      easeInQuart: function easeInQuart(e, t, n, r, i) {
        return r * (t /= i) * t * t * t + n;
      },
      easeOutQuart: function easeOutQuart(e, t, n, r, i) {
        return -r * ((t = t / i - 1) * t * t * t - 1) + n;
      },
      easeInOutQuart: function easeInOutQuart(e, t, n, r, i) {
        return (t /= i / 2) < 1 ? r / 2 * t * t * t * t + n : -r / 2 * ((t -= 2) * t * t * t - 2) + n;
      },
      easeInQuint: function easeInQuint(e, t, n, r, i) {
        return r * (t /= i) * t * t * t * t + n;
      },
      easeOutQuint: function easeOutQuint(e, t, n, r, i) {
        return r * ((t = t / i - 1) * t * t * t * t + 1) + n;
      },
      easeInOutQuint: function easeInOutQuint(e, t, n, r, i) {
        return (t /= i / 2) < 1 ? r / 2 * t * t * t * t * t + n : r / 2 * ((t -= 2) * t * t * t * t + 2) + n;
      },
      easeInSine: function easeInSine(e, t, n, r, i) {
        return -r * Math.cos(t / i * (Math.PI / 2)) + r + n;
      },
      easeOutSine: function easeOutSine(e, t, n, r, i) {
        return r * Math.sin(t / i * (Math.PI / 2)) + n;
      },
      easeInOutSine: function easeInOutSine(e, t, n, r, i) {
        return -r / 2 * (Math.cos(Math.PI * t / i) - 1) + n;
      },
      easeInExpo: function easeInExpo(e, t, n, r, i) {
        return 0 == t ? n : r * Math.pow(2, 10 * (t / i - 1)) + n;
      },
      easeOutExpo: function easeOutExpo(e, t, n, r, i) {
        return t == i ? n + r : r * (1 - Math.pow(2, -10 * t / i)) + n;
      },
      easeInOutExpo: function easeInOutExpo(e, t, n, r, i) {
        return 0 == t ? n : t == i ? n + r : (t /= i / 2) < 1 ? r / 2 * Math.pow(2, 10 * (t - 1)) + n : r / 2 * (2 - Math.pow(2, -10 * --t)) + n;
      },
      easeInCirc: function easeInCirc(e, t, n, r, i) {
        return -r * (Math.sqrt(1 - (t /= i) * t) - 1) + n;
      },
      easeOutCirc: function easeOutCirc(e, t, n, r, i) {
        return r * Math.sqrt(1 - (t = t / i - 1) * t) + n;
      },
      easeInOutCirc: function easeInOutCirc(e, t, n, r, i) {
        return (t /= i / 2) < 1 ? -r / 2 * (Math.sqrt(1 - t * t) - 1) + n : r / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + n;
      },
      easeInElastic: function easeInElastic(e, t, n, r, i) {
        var o = 1.70158,
            s = 0,
            a = r;
        if (0 == t) return n;
        if (1 == (t /= i)) return n + r;

        if (s || (s = .3 * i), a < Math.abs(r)) {
          a = r;
          o = s / 4;
        } else o = s / (2 * Math.PI) * Math.asin(r / a);

        return -a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * i - o) * (2 * Math.PI) / s) + n;
      },
      easeOutElastic: function easeOutElastic(e, t, n, r, i) {
        var o = 1.70158,
            s = 0,
            a = r;
        if (0 == t) return n;
        if (1 == (t /= i)) return n + r;

        if (s || (s = .3 * i), a < Math.abs(r)) {
          a = r;
          o = s / 4;
        } else o = s / (2 * Math.PI) * Math.asin(r / a);

        return a * Math.pow(2, -10 * t) * Math.sin((t * i - o) * (2 * Math.PI) / s) + r + n;
      },
      easeInOutElastic: function easeInOutElastic(e, t, n, r, i) {
        var o = 1.70158,
            s = 0,
            a = r;
        if (0 == t) return n;
        if (2 == (t /= i / 2)) return n + r;

        if (s || (s = i * (.3 * 1.5)), a < Math.abs(r)) {
          a = r;
          o = s / 4;
        } else o = s / (2 * Math.PI) * Math.asin(r / a);

        return t < 1 ? a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * i - o) * (2 * Math.PI) / s) * -.5 + n : a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * i - o) * (2 * Math.PI) / s) * .5 + r + n;
      },
      easeInBack: function easeInBack(e, t, n, r, i, o) {
        return null == o && (o = 1.70158), r * (t /= i) * t * ((o + 1) * t - o) + n;
      },
      easeOutBack: function easeOutBack(e, t, n, r, i, o) {
        return null == o && (o = 1.70158), r * ((t = t / i - 1) * t * ((o + 1) * t + o) + 1) + n;
      },
      easeInOutBack: function easeInOutBack(e, t, n, r, i, o) {
        return null == o && (o = 1.70158), (t /= i / 2) < 1 ? r / 2 * (t * t * ((1 + (o *= 1.525)) * t - o)) + n : r / 2 * ((t -= 2) * t * ((1 + (o *= 1.525)) * t + o) + 2) + n;
      },
      easeInBounce: function easeInBounce(t, n, r, i, o) {
        return i - e.easing.easeOutBounce(t, o - n, 0, i, o) + r;
      },
      easeOutBounce: function easeOutBounce(e, t, n, r, i) {
        return (t /= i) < 1 / 2.75 ? r * (7.5625 * t * t) + n : t < 2 / 2.75 ? r * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + n : t < 2.5 / 2.75 ? r * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + n : r * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + n;
      },
      easeInOutBounce: function easeInOutBounce(t, n, r, i, o) {
        return n < o / 2 ? .5 * e.easing.easeInBounce(t, 2 * n, 0, i, o) + r : .5 * e.easing.easeOutBounce(t, 2 * n - o, 0, i, o) + .5 * i + r;
      }
    });
  }).call(this, n(2));
},,,,,,,,, function (e, t, n) {
  "use strict";

  n.r(t);
  n(4);
  var r = n(1),
      i = n(3);
  Object(r.c)(), Object(r.a)("[class*=p-page-navi-banner--]", "[class*=c-stroke-btn--]"), Object(r.b)("[class*=p-page-navi-banner--]"), Object(r.b)(".p-recipe-index__item"), Object(r.b)(".p-recipe-detail__section"), Object(r.b)(".p-recipe-detail__ingredients"), Object(r.b)(".p-recipe-detail__directions"), Object(i.e)();
}]);